webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "2ZkL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5IE1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6cjY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7M5x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8YmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HVqO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JRtP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K3jJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M9V4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/css/reset.css
var css_reset = __webpack_require__("xsZ7");
var reset_default = /*#__PURE__*/__webpack_require__.n(css_reset);

// EXTERNAL MODULE: ./src/css/base.css
var base = __webpack_require__("dNEa");
var base_default = /*#__PURE__*/__webpack_require__.n(base);

// EXTERNAL MODULE: ./src/css/badge.css
var badge = __webpack_require__("pz9T");
var badge_default = /*#__PURE__*/__webpack_require__.n(badge);

// EXTERNAL MODULE: ./src/css/breadcrumb.css
var breadcrumb = __webpack_require__("S4k7");
var breadcrumb_default = /*#__PURE__*/__webpack_require__.n(breadcrumb);

// EXTERNAL MODULE: ./src/css/button.css
var css_button = __webpack_require__("tYzW");
var button_default = /*#__PURE__*/__webpack_require__.n(css_button);

// EXTERNAL MODULE: ./src/css/form.css
var css_form = __webpack_require__("HVqO");
var form_default = /*#__PURE__*/__webpack_require__.n(css_form);

// EXTERNAL MODULE: ./src/css/grid.css
var grid = __webpack_require__("6cjY");
var grid_default = /*#__PURE__*/__webpack_require__.n(grid);

// EXTERNAL MODULE: ./src/css/header.css
var header = __webpack_require__("2ZkL");
var header_default = /*#__PURE__*/__webpack_require__.n(header);

// EXTERNAL MODULE: ./src/css/item.css
var item = __webpack_require__("5IE1");
var item_default = /*#__PURE__*/__webpack_require__.n(item);

// EXTERNAL MODULE: ./src/css/overlay.css
var overlay = __webpack_require__("M9V4");
var overlay_default = /*#__PURE__*/__webpack_require__.n(overlay);

// EXTERNAL MODULE: ./src/css/share.css
var share = __webpack_require__("yg31");
var share_default = /*#__PURE__*/__webpack_require__.n(share);

// EXTERNAL MODULE: ./src/css/splash.css
var splash = __webpack_require__("7M5x");
var splash_default = /*#__PURE__*/__webpack_require__.n(splash);

// EXTERNAL MODULE: ./src/css/tabs.css
var tabs = __webpack_require__("K3jJ");
var tabs_default = /*#__PURE__*/__webpack_require__.n(tabs);

// EXTERNAL MODULE: ./src/css/votes.css
var votes = __webpack_require__("pb+Z");
var votes_default = /*#__PURE__*/__webpack_require__.n(votes);

// EXTERNAL MODULE: ./src/css/category.css
var category = __webpack_require__("8YmM");
var category_default = /*#__PURE__*/__webpack_require__.n(category);

// EXTERNAL MODULE: ./src/css/home.css
var home = __webpack_require__("lONR");
var home_default = /*#__PURE__*/__webpack_require__.n(home);

// EXTERNAL MODULE: ./src/css/selection.css
var selection = __webpack_require__("czUQ");
var selection_default = /*#__PURE__*/__webpack_require__.n(selection);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Loader.vue
//
//
//
//
//
//
//

/* harmony default export */ var Loader = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3afc75cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
var Loader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"cube1"}),_vm._v(" "),_c('div',{staticClass:"cube2"})])}]
var esExports = { render: Loader_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Loader = (esExports);
// CONCATENATED MODULE: ./src/components/Loader.vue
function injectStyle (ssrContext) {
  __webpack_require__("JRtP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Loader,
  components_Loader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Loader = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/util/request.js

var mode = 'cors';
var headers = {
  'access-token': "A2aui2A2HFdxJh8Kuhdmq2EawBHr3DE",
  Accept: 'application/vnd.' + "dutch-reality-awards" + '.api+json;version=v' + "1"
};

var get = function get(endpoint) {
  return fetch("https://dutch-reality-awards.abcvoting.com" + '/' + endpoint, {
    mode: mode,
    headers: headers
  });
};

var request_post = function post(endpoint) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var body = new FormData();

  keys_default()(data).forEach(function (key) {
    body.append(key, data[key]);
  });

  return fetch("https://dutch-reality-awards.abcvoting.com" + '/' + endpoint, {
    mode: mode,
    headers: headers,
    body: body,
    method: 'POST'
  });
};
// CONCATENATED MODULE: ./src/sortTypes.js
var SORT_ASC = 0;
var SORT_DESC = 1;
var SORT_RANDOM = 2;
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify = __webpack_require__("wffv");
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Tabs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Tabs = ({
  name: 'Tabs',

  props: {
    selectedId: Number
  },

  methods: {
    classForCategory: function classForCategory(category) {
      return {
        tab: true,
        'tab--selected': this.hasSelectedSuggestion(category)
      };
    },
    changeCategory: function changeCategory() {
      this.$emit('changeCategory');
    },
    urlForCategory: function urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug
        }
      };
    },
    getSelectedNominee: function getSelectedNominee(category) {
      var selected = this.selected.find(function (_ref) {
        var categoryId = _ref.categoryId;
        return categoryId === category.id;
      });

      if (!selected) {
        return null;
      }

      var nominees = this.$store.getters.getNomineesByCategoryId(category.id);

      return nominees.find(function (nominee) {
        return nominee.id === selected.nomineeId;
      });
    },
    getSelectedSuggestion: function getSelectedSuggestion(category) {
      var selected = this.selected.find(function (_ref2) {
        var categoryId = _ref2.categoryId;
        return categoryId === category.id;
      });

      if (!selected) {
        return null;
      }

      var suggestions = this.$store.state.suggestions;
      return suggestions.find(function (suggestion) {
        return suggestion.categoryId === selected.categoryId;
      });
    },
    hasSelectedSuggestion: function hasSelectedSuggestion(category) {
      return this.selected.find(function (_ref3) {
        var categoryId = _ref3.categoryId;
        return categoryId === category.id;
      }) != null;
    },
    hasSelectedNominee: function hasSelectedNominee(category) {
      return this.getSelectedNominee(category) != null;
    }
  },

  computed: {
    categories: function categories() {
      return this.$store.state.categories;
    },
    selected: function selected() {
      return this.$store.state.selected;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0196a9ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs.vue
var Tabs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"tabs"},_vm._l((_vm.categories),function(category){return _c('router-link',{key:category.id,class:_vm.classForCategory(category),attrs:{"active-class":"tab--active","to":_vm.urlForCategory(category)},nativeOn:{"click":function($event){return _vm.changeCategory()}}},[_c('strong',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('span',[(_vm.hasSelectedSuggestion(category))?_c('i',{staticClass:"fa fa-check"}):_vm._e()]),_vm._v(" "),(_vm.hasSelectedNominee(category))?_c('p',[_vm._v("\n      "+_vm._s(_vm.getSelectedNominee(category).name)+"\n    ")]):(_vm.hasSelectedSuggestion(category))?_c('p',[_vm._v("\n      "+_vm._s(_vm.getSelectedSuggestion(category).suggestionName)+"\n    ")]):_vm._e()])}),1)}
var Tabs_staticRenderFns = []
var Tabs_esExports = { render: Tabs_render, staticRenderFns: Tabs_staticRenderFns }
/* harmony default export */ var components_Tabs = (Tabs_esExports);
// CONCATENATED MODULE: ./src/components/Tabs.vue
var Tabs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Tabs___vue_template_functional__ = false
/* styles */
var Tabs___vue_styles__ = null
/* scopeId */
var Tabs___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Tabs___vue_module_identifier__ = null
var Tabs_Component = Tabs_normalizeComponent(
  Tabs,
  components_Tabs,
  Tabs___vue_template_functional__,
  Tabs___vue_styles__,
  Tabs___vue_scopeId__,
  Tabs___vue_module_identifier__
)

/* harmony default export */ var src_components_Tabs = (Tabs_Component.exports);

// CONCATENATED MODULE: ./src/util/firstRound.js
function isFirstRound() {
  if (this.round.allow_suggestions && this.categories.length !== 0) {
    return this.categories.every(function (category) {
      return category.nomineeIds.length === 0;
    });
  }
  return false;
}

/* harmony default export */ var firstRound = (isFirstRound);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Selection.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Selection = ({
  name: 'Selection',

  methods: {
    isFirstRound: firstRound,
    getOpenCategory: function getOpenCategory() {
      var _this = this;

      var category = this.categories.find(function (category) {
        return !_this.usedCategoryIds.includes(category.id);
      });
      if (!category) {
        return {
          name: 'home'
        };
      }

      return {
        name: 'category',
        params: {
          categorySlug: category.slug
        }
      };
    },
    findCategoryById: function findCategoryById(categoryId) {
      return this.categories.find(function (category) {
        return category.id === categoryId;
      });
    },
    clearCategory: function clearCategory(category) {
      this.$store.dispatch('clearCategory', {
        categoryId: category.id
      });

      this.$router.push(this.urlForCategory(category)).catch(function (err) {
        return console.warn(err);
      });
    },
    clearSuggestionCategory: function clearSuggestionCategory(categoryId) {
      this.$store.dispatch('clearCategory', {
        categoryId: categoryId
      });
      this.$router.push({
        name: 'home'
      });
    },
    urlForCategory: function urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug
        }
      };
    },
    stylesForNominee: function stylesForNominee(nominee) {
      return nominee.image ? {
        backgroundImage: 'linear-gradient(0deg, #121212, transparent), url(' + nominee.image + ')'
      } : {};
    },
    stylesForSuggestion: function stylesForSuggestion() {
      return {
        backgroundImage: 'linear-gradient(0deg, #121212, transparent), url(/static/base_icon.png)'
      };
    },
    getCategoryName: function getCategoryName(categoryId) {
      var category = this.$store.state.categories.find(function (category) {
        return category.id === categoryId;
      });
      return category.name;
    }
  },

  computed: {
    selection: function selection() {
      // return this.$store.getters.selection.map(({ nominee }) => nominee).filter(nominee => nominee);
      return this.$store.getters.selection.map(function (_ref) {
        var suggestion = _ref.suggestion,
            nominee = _ref.nominee;
        return { suggestion: suggestion, nominee: nominee };
      }).filter(function (_ref2) {
        var suggestion = _ref2.suggestion,
            nominee = _ref2.nominee;
        return suggestion || nominee;
      });
    },
    usedCategoryIds: function usedCategoryIds() {
      return this.$store.getters.selection.map(function (item) {
        if (item.nominee && item.nominee.category) {
          return item.nominee.category.id;
        }
        if (item.suggestion) {
          return item.suggestion.categoryId;
        }
        return undefined;
      }).filter(function (categoryId) {
        return categoryId !== undefined;
      });
    },
    categories: function categories() {
      return this.$store.state.categories;
    },
    round: function round() {
      return this.$store.state.rounds[0];
    },
    canAdd: function canAdd() {
      return this.$store.getters.selection.length > this.selection.length;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a355a96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Selection.vue
var Selection_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selection__grid"},[_vm._l((_vm.selection),function(item){return _c('div',{key:item.id,staticClass:"selection__item"},[(item.nominee && !item.suggestion)?_c('div',[_c('h3',[_vm._v(_vm._s(item.nominee.category.name))]),_vm._v(" "),_c('div',{staticClass:"selection__card__image__contained",style:(_vm.stylesForNominee(item.nominee))},[_c('b',{staticStyle:{"color":"#faf9f6"}},[_vm._v(_vm._s(item.nominee.name))]),_vm._v(" "),_c('b',{staticStyle:{"color":"#faf9f6"}},[_vm._v(_vm._s(item.nominee.platform))]),_vm._v(" "),_c('a',{staticClass:"button button--small",attrs:{"href":_vm.urlForCategory(item.nominee.category)},on:{"click":function($event){$event.preventDefault();return _vm.clearCategory(item.nominee.category)}}},[_vm._v("\n          Stem wijzigen\n        ")])])]):_vm._e(),_vm._v(" "),(item.suggestion && !item.nominee && !_vm.isFirstRound)?_c('div',[_c('h3',[_vm._v(_vm._s(_vm.getCategoryName(item.suggestion.categoryId)))]),_vm._v(" "),_c('div',{staticClass:"selection__card__image__contained",style:(_vm.stylesForSuggestion())},[_c('b',{staticStyle:{"color":"#faf9f6"}},[_vm._v(_vm._s(item.suggestion.suggestionName))]),_vm._v(" "),_c('a',{staticClass:"button button--small",attrs:{"href":_vm.urlForCategory(_vm.findCategoryById(item.suggestion.categoryId))},on:{"click":function($event){$event.preventDefault();_vm.clearCategory(_vm.findCategoryById(item.suggestion.categoryId))}}},[_vm._v("\n          Stem wijzigen\n        ")])])]):_vm._e(),_vm._v(" "),(item.suggestion && !item.nominee && _vm.isFirstRound)?_c('div',[_c('h3',[_vm._v(_vm._s(_vm.getCategoryName(item.suggestion.categoryId)))]),_vm._v(" "),_c('div',{staticClass:"selection__card__image__contained",style:(_vm.stylesForSuggestion())},[_c('b',{staticStyle:{"color":"#faf9f6"}},[_vm._v(_vm._s(item.suggestion.suggestionName))]),_vm._v(" "),_c('a',{staticClass:"button button--small",attrs:{"href":"/#/"},on:{"click":function($event){$event.preventDefault();return _vm.clearSuggestionCategory(item.suggestion.categoryId)}}},[_vm._v("\n          Stem wijzigen\n        ")])])]):_vm._e()])}),_vm._v(" "),(_vm.canAdd && !_vm.isFirstRound())?_c('div',{staticClass:"selection__item"},[_c('router-link',{staticClass:"selection__card selection__card--empty",attrs:{"to":_vm.getOpenCategory()}},[_c('span',[_vm._v("Stem op nog een categorie")])])],1):_vm._e()],2)}
var Selection_staticRenderFns = []
var Selection_esExports = { render: Selection_render, staticRenderFns: Selection_staticRenderFns }
/* harmony default export */ var components_Selection = (Selection_esExports);
// CONCATENATED MODULE: ./src/components/Selection.vue
var Selection_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Selection___vue_template_functional__ = false
/* styles */
var Selection___vue_styles__ = null
/* scopeId */
var Selection___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Selection___vue_module_identifier__ = null
var Selection_Component = Selection_normalizeComponent(
  Selection,
  components_Selection,
  Selection___vue_template_functional__,
  Selection___vue_styles__,
  Selection___vue_scopeId__,
  Selection___vue_module_identifier__
)

/* harmony default export */ var src_components_Selection = (Selection_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/util/listen.js
var listen = function listen(el, event, callback) {
  el.addEventListener(event, callback);
  return function () {
    el.removeEventListener(event, callback);
  };
};

/* harmony default export */ var util_listen = (listen);
// CONCATENATED MODULE: ./src/util/throttle.js
var throttle = function throttle(fn) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var last = 0;
  var deferTimer = null;
  return function () {
    var context = scope || this;
    var now = Date.now();
    var args = arguments;
    if (last && now < last + threshold) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};

/* harmony default export */ var util_throttle = (throttle);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SuggestionModal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MIN_HEIGHT = 490;
var _document = document,
    documentElement = _document.documentElement;


/* harmony default export */ var SuggestionModal = ({
  name: 'Suggestion',
  props: {
    categoryId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      listeners: [],
      minHeight: MIN_HEIGHT,
      windowHeight: window.innerHeight,
      suggestionName: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var detectWindowHeight = util_throttle(function () {
      _this.windowHeight = window.innerHeight;
    }, 500);

    this.listeners = [util_listen(window, 'keyup', this.onKeyUp), util_listen(window, 'resize', detectWindowHeight)];

    documentElement.classList.add('no-scroll');
  },
  beforeDestroy: function beforeDestroy() {
    this.listeners.forEach(function (unlisten) {
      return unlisten();
    });
    documentElement.classList.remove('no-scroll');
  },

  methods: {
    submit: function submit() {
      if (this.isValid()) {
        this.addSuggestion();
      }
    },
    onKeyUp: function onKeyUp(e) {
      if (e.keyCode === 27) {
        this.$emit('closeModal');
      }
    },
    isValid: function isValid() {
      return this.suggestionName && this.suggestionName.trim().length > 0;
    },
    isIncomplete: function isIncomplete() {
      return !this.isValid();
    },
    addSuggestion: function addSuggestion() {
      var categoryId = this.categoryId,
          suggestionName = this.suggestionName;

      this.$store.dispatch('addSuggestion', {
        categoryId: categoryId,
        suggestionName: suggestionName
      });
      this.$emit('closeModal');
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(['selected', 'categories']), {
    category: function category() {
      var _this2 = this;

      return this.categories.find(function (_ref) {
        var id = _ref.id;
        return id === _this2.categoryId;
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0adf5cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SuggestionModal.vue
var SuggestionModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.category)?_c('div',[_c('div',{staticClass:"overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$emit('closeModal')}}},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__head"},[_c('h1',[_vm._v("\n          "+_vm._s(_vm.category.name)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"modal__close",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$emit('closeModal')}}},[_c('i',{staticClass:"fa fa-lg fa-close",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"modal__body"},[_c('p',{staticClass:"mb--lg"},[_c('strong',[_vm._v("\n            Voeg je eigen suggestie toe voor de categorie '"+_vm._s(_vm.category.name.toLowerCase())+"'.")])]),_vm._v(" "),[_vm._m(0)],_vm._v(" "),_c('form',{ref:"form",staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"form__field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.suggestionName),expression:"suggestionName"}],staticClass:"form__input",staticStyle:{"background-color":"#121212","color":"#faf9f6","border":"solid 1px #f2ad07","margin-bottom":"1rem"},attrs:{"type":"text","required":"","placeholder":"Naam en programma*","id":"form__field_name"},domProps:{"value":(_vm.suggestionName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.suggestionName=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"button button--fullwidth",attrs:{"disabled":_vm.isIncomplete()},on:{"click":function($event){$event.preventDefault();return _vm.addSuggestion.apply(null, arguments)}}},[_vm._v("\n            Voeg suggestie toe\n          ")])])],2),_vm._v(" "),_c('div',{class:{
          'p--lg': _vm.windowHeight >= _vm.minHeight,
          'p--md': _vm.windowHeight < _vm.minHeight
        }})])])]):_vm._e()}
var SuggestionModal_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Wat is de "),_c('b',[_vm._v("naam")]),_vm._v(" en het "),_c('b',[_vm._v("programma")]),_vm._v(" van de suggestie?")])}]
var SuggestionModal_esExports = { render: SuggestionModal_render, staticRenderFns: SuggestionModal_staticRenderFns }
/* harmony default export */ var components_SuggestionModal = (SuggestionModal_esExports);
// CONCATENATED MODULE: ./src/components/SuggestionModal.vue
var SuggestionModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SuggestionModal___vue_template_functional__ = false
/* styles */
var SuggestionModal___vue_styles__ = null
/* scopeId */
var SuggestionModal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SuggestionModal___vue_module_identifier__ = null
var SuggestionModal_Component = SuggestionModal_normalizeComponent(
  SuggestionModal,
  components_SuggestionModal,
  SuggestionModal___vue_template_functional__,
  SuggestionModal___vue_styles__,
  SuggestionModal___vue_scopeId__,
  SuggestionModal___vue_module_identifier__
)

/* harmony default export */ var src_components_SuggestionModal = (SuggestionModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Category.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Category = ({
  name: 'Category',

  components: {
    tabs: src_components_Tabs,
    selection: src_components_Selection,
    suggestionModal: src_components_SuggestionModal
  },

  props: {
    categorySlug: {
      type: String,
      required: true
    },

    nomineeId: {
      type: Number,
      required: false
    }
  },

  data: function data() {
    return {
      selectedId: null,
      showSuggestionModal: false
    };
  },


  methods: {
    select: function select(nominee) {
      this.selectedId = nominee.id;
    },
    vote: function vote() {
      var category = this.category,
          selectedId = this.selectedId;


      if (selectedId && category) {
        this.$store.dispatch('selectNominee', { categoryId: category.id, nomineeId: selectedId });
      }
    },
    clearCategory: function clearCategory() {
      this.$store.dispatch('clearCategory', {
        categoryId: this.category.id
      });
    },
    stylesForNominee: function stylesForNominee(nominee) {
      return nominee.image ? {
        backgroundImage: 'linear-gradient(0deg, #121212, transparent), url(' + nominee.image + ')'
      } : {};
    },
    classForGridItem: function classForGridItem(nominee) {
      return {
        grid__item: true,
        'grid__item--selected': nominee.id === this.selectedId
      };
    },
    urlForCategory: function urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug
        }
      };
    },
    urlForNominee: function urlForNominee(nominee) {
      return {
        name: 'nominee',
        params: {
          categoryId: this.category.id,
          nomineeId: nominee.id,
          nomineeSlug: nominee.slug
        }
      };
    },
    classForNominee: function classForNominee(nominee) {
      return {
        item: true,
        'item--nominee': true,
        'item--disabled': this.activeNominee && !(this.activeNominee.id === nominee.id),
        'item--selected': this.isSelectedNominee(nominee)
      };
    },
    isSelectedNominee: function isSelectedNominee(nominee) {
      return this.selected.find(function (_ref) {
        var nomineeId = _ref.nomineeId;
        return nomineeId === nominee.id;
      });
    },
    hasSelectedNominee: function hasSelectedNominee(category) {
      return this.selected.find(function (_ref2) {
        var categoryId = _ref2.categoryId;
        return categoryId === category.id;
      });
    },
    clearSelectedId: function clearSelectedId() {
      if (this.selectedId != null) {
        this.selectedId = null;
      }
    }
  },

  computed: {
    selectedItem: function selectedItem() {
      var _this = this;

      return this.filteredNominees.find(function (item) {
        return item.id === _this.selectedId;
      });
    },
    canVote: function canVote() {
      return this.selectedItem != null;
    },
    selected: function selected() {
      return this.$store.state.selected;
    },
    suggestions: function suggestions() {
      return this.$store.state.suggestions;
    },
    loaded: function loaded() {
      return this.$store.state.loaded;
    },
    selection: function selection() {
      return this.$store.getters.selection.map(function (_ref3) {
        var nominee = _ref3.nominee;
        return nominee;
      }).filter(function (nominee) {
        return nominee;
      });
    },
    canAdd: function canAdd() {
      return this.$store.getters.selection.length > this.selection.length;
    },
    selectedNominee: function selectedNominee() {
      var _this2 = this;

      var selected = this.selected.find(function (_ref4) {
        var categoryId = _ref4.categoryId;
        return categoryId === _this2.category.id;
      });
      var searchNominee = selected ? this.nominees.find(function (nominee) {
        return nominee.id === selected.nomineeId;
      }) : null;

      if (!searchNominee) {
        return selected ? this.suggestions.find(function (suggestion) {
          return suggestion.categoryId === selected.categoryId;
        }) : null;
      } else {
        return searchNominee;
      }
    },
    categories: function categories() {
      return this.$store.state.categories;
    },
    category: function category() {
      var _this3 = this;

      return this.categories.find(function (_ref5) {
        var slug = _ref5.slug;
        return slug === _this3.categorySlug;
      });
    },
    nominees: function nominees() {
      return this.$store.getters.getNomineesByCategoryId(this.category.id);
    },
    activeNominee: function activeNominee() {
      var _this4 = this;

      return this.nomineeId ? this.filteredNominees.find(function (_ref6) {
        var id = _ref6.id;
        return id === _this4.nomineeId;
      }) : null;
    },
    filteredNominees: function filteredNominees() {
      return this.$store.getters.getFilteredNomineesByCategoryId(this.category.id);
    },
    allowSuggestions: function allowSuggestions() {
      return this.$store.state.allowSuggestions;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c049839e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Category.vue
var Category_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.category)?_c('div',{staticClass:"category"},[(!_vm.selectedNominee)?_c('tabs',{on:{"changeCategory":_vm.clearSelectedId}}):_vm._e(),_vm._v(" "),(_vm.selectedNominee)?_c('div',{staticClass:"selection"},[_c('h1',{staticClass:"title",staticStyle:{"color":"#faf9f6","text-decoration":"underline","margin":"auto"}},[_vm._v("Jouw keuze(s)")]),_vm._v(" "),_c('selection'),_vm._v(" "),_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'submit' }}},[_vm._v(" Stemmen afronden ")])],1):[_c('div',{staticStyle:{"justify-content":"space-between","display":"inline-flex"}},[_c('h1',{staticClass:"title",staticStyle:{"color":"#faf9f6"}},[_vm._v(_vm._s(_vm.category.name))]),_vm._v(" "),(_vm.allowSuggestions)?_c('a',{staticClass:"suggestion__button",on:{"click":function($event){_vm.showSuggestionModal = true}}},[_vm._v("\n        Voeg hier zelf een suggestie toe\n      ")]):_vm._e()]),_vm._v(" "),(_vm.filteredNominees.length)?_c('div',{key:_vm.category.id,ref:"grid",staticClass:"grid"},_vm._l((_vm.filteredNominees),function(nominee){return _c('div',{key:nominee.id,class:_vm.classForGridItem(nominee),staticStyle:{"text-align":"center","align-content":"end"},style:(_vm.stylesForNominee(nominee)),attrs:{"role":"button","tabindex":"0","title":nominee.name},on:{"click":function($event){return _vm.select(nominee)}}},[_c('b',{staticStyle:{"color":"#faf9f6","font-size":"80%"}},[_vm._v(_vm._s(nominee.name))]),_c('br'),_vm._v(" "),(nominee.platform)?_c('b',{staticStyle:{"color":"#faf9f6","font-size":"60%"}},[_vm._v(_vm._s(nominee.platform))]):_vm._e()])}),0):_c('p',{staticStyle:{"color":"#faf9f6"}},[_vm._v("Er zijn geen genomineerden gevonden binnen de opgegeven criteria.")]),_vm._v(" "),_c('div',{staticClass:"floating-button"},[(_vm.filteredNominees.length)?_c('button',{staticClass:"button",attrs:{"disabled":!_vm.canVote},on:{"click":_vm.vote}},[_vm._v("\n        Stem nu\n      ")]):_vm._e()])],_vm._v(" "),(_vm.showSuggestionModal)?_c('suggestion-modal',{attrs:{"category-id":_vm.category.id},on:{"closeModal":function($event){_vm.showSuggestionModal = false}}}):_vm._e()],2):_c('p',[_vm._v("\n  Deze pagina bestaat niet (meer).\n  "),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Klik hier om terug te keren naar de homepage")]),_vm._v(".\n")],1)}
var Category_staticRenderFns = []
var Category_esExports = { render: Category_render, staticRenderFns: Category_staticRenderFns }
/* harmony default export */ var components_Category = (Category_esExports);
// CONCATENATED MODULE: ./src/components/Category.vue
var Category_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Category___vue_template_functional__ = false
/* styles */
var Category___vue_styles__ = null
/* scopeId */
var Category___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Category___vue_module_identifier__ = null
var Category_Component = Category_normalizeComponent(
  Category,
  components_Category,
  Category___vue_template_functional__,
  Category___vue_styles__,
  Category___vue_scopeId__,
  Category___vue_module_identifier__
)

/* harmony default export */ var src_components_Category = (Category_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var CDN_DOMAIN = "https://dutch-reality-awards.abcvoting.com";


/* harmony default export */ var App = ({
  name: 'app',
  components: {
    loader: src_components_Loader
  },
  computed: {
    loaded: function loaded() {
      return this.$store.state.loaded;
    }
  },
  mounted: function mounted() {
    var _this = this;

    get('voting/round').then(function (response) {
      return response.json();
    }).then(function (data) {
      var rounds = values_default()(data || {}).map(function (_ref) {
        var id = _ref.id,
            name = _ref.name,
            description = _ref.description,
            categories = _ref.categories,
            suggestions_max = _ref.suggestions_max,
            allow_suggestions = _ref.allow_suggestions;

        return {
          id: Number(id),
          name: name,
          description: description,
          image: null,
          categoryIds: categories.data.map(function (_ref2) {
            var id = _ref2.id;
            return Number(id);
          }),
          suggestions_max: suggestions_max,
          allow_suggestions: allow_suggestions
        };
      });
      _this.$store.dispatch('setAllowSuggestions', rounds[0].allow_suggestions && rounds[0].suggestions_max > 0);

      var categories = data.data.categories.data.map(function (_ref3) {
        var id = _ref3.id,
            name = _ref3.name;

        if (name.includes(' | ')) {
          var categoryText = name.split(' | ');
          return {
            id: Number(id),
            name: categoryText[0],
            placeholder: categoryText[1],
            slug: slugify_default()(name, { lower: true, remove: /[/:]/g }),
            nomineeIds: data.data.nominees.data.filter(function (nominee) {
              return nominee.categories.includes(Number(id));
            }).map(function (_ref4) {
              var id = _ref4.id;
              return Number(id);
            }),
            round: {},
            sortType: SORT_RANDOM,
            selectedChannelId: null,
            selectedDayPartId: null,
            keyword: ''
          };
        } else {
          return {
            id: Number(id),
            name: name,
            slug: slugify_default()(name, { lower: true }),
            nomineeIds: data.data.nominees.data.filter(function (nominee) {
              return nominee.categories.includes(Number(id));
            }).map(function (_ref5) {
              var id = _ref5.id;
              return Number(id);
            }),
            round: {},
            sortType: SORT_RANDOM,
            selectedChannelId: null,
            selectedDayPartId: null,
            keyword: ''
          };
        }
      });

      var nominees = [];

      data.data.nominees.data.forEach(function (nominee) {
        nominee.categories.forEach(function (nomineeCategory) {
          var src = nominee.image ? nominee.image.data.src : null;

          nominees.push({
            id: Number(nominee.id),
            name: nominee.name,
            slug: nominee.slug,
            hashtag: '',
            hometown: '',
            secondaryName: '',
            knownFor: '',
            image: src,
            imageThumb: src,
            category: categories.find(function (category) {
              return category.id === nomineeCategory;
            }),
            tags: [],
            platform: nominee.program_platform,
            url: nominee.url
          });
        });
      });

      _this.$store.dispatch('setRounds', rounds);
      _this.$store.dispatch('setCategories', categories);
      _this.$store.dispatch('setNominees', nominees);
      _this.$store.dispatch('setLoaded', true);
    }).catch(function () {
      _this.$store.dispatch('setLoaded', true);
      _this.$store.dispatch('setFailedFetch', true);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9faab48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"header"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v(" Dutch Reality Awards ")])],1),_vm._v(" "),(_vm.loaded)?_c('router-view'):_c('loader'),_vm._v(" "),_c('footer',[_c('div',{staticStyle:{"display":"flex","justify-content":"center","text-align":"center"}},[_c('div',{staticClass:"mx-auto w-18 pb-2 text-center"},[_vm._m(0),_vm._v(" "),_c('a',{attrs:{"href":"https://angrybytes.com/","target":"_blank","title":"Angry Bytes"}},[_c('svg',{staticClass:"block w-full",attrs:{"width":"50%","height":"50%","viewBox":"0 0 753.357 131.043"}},[_c('path',{attrs:{"fill":"#d9a22e","d":"M4.724 42.922c8.546-5.398 18.442-8.097 29.688-8.097 8.098 0 14.508 2.25 19.23 6.747 4.724 4.499 7.085 11.246 7.085 20.242v40.484H41.835V96.9c-5.489 3.6-10.437 5.398-14.845 5.398-8.997 0-15.745-1.91-20.242-5.734C2.249 92.74 0 87.455 0 80.707 0 74.41 2.126 68.788 6.377 63.84s11.121-7.423 20.613-7.423c4.362 0 9.312 1.35 14.845 4.048v-2.023c-.091-4.948-3.689-7.647-10.796-8.098-8.098 0-14.396 1.35-18.894 4.049L4.724 42.922zm37.111 39.135v-7.624c-1.8-3.463-6.073-5.195-12.82-5.195-8.097.9-12.371 4.049-12.82 9.446.449 5.354 4.724 8.254 12.82 8.703 6.747 0 11.02-1.776 12.82-5.33zM86.815 59.386v42.913H67.923V36.781l18.893-2.023v6.14c4.543-4.048 9.941-6.072 16.194-6.072 8.546 0 15.069 2.587 19.567 7.76s6.748 11.133 6.748 17.88V102.3h-18.894V65.189c0-4.498-1.125-7.984-3.373-10.46-2.25-2.473-5.646-3.778-10.188-3.913-3.914.27-7.266 3.127-10.055 8.57zM199.2 36.85V96.9c0 9.447-2.812 17.342-8.434 23.684-5.624 6.344-12.709 9.693-21.255 10.055l-4.049.404c-13.045-.27-23.167-4.004-30.363-11.201l8.771-10.121c4.948 3.6 10.953 5.623 18.016 6.074 7.197 0 12.066-1.688 14.608-5.061 2.541-3.375 3.812-7.086 3.812-11.135v-3.373c-5.038 4.049-10.887 6.072-17.543 6.072-10.347 0-18.106-3.035-23.279-9.109-5.173-6.072-7.76-14.281-7.76-24.627 0-9.896 2.812-17.993 8.435-24.291s13.606-9.446 23.954-9.446c7.646.45 13.044 2.496 16.193 6.14v-6.14L199.2 36.85zm-18.892 37.785V63.704c-.9-7.558-5.623-11.987-14.17-13.293-11.246.405-17.318 6.006-18.218 16.802.449 12.596 6.521 19.117 18.218 19.566 8.546-1.349 13.269-5.396 14.17-12.144zM220.44 42.247c4.812-4.947 10.683-7.422 17.61-7.422 2.204 0 4.296.18 6.275.539l-2.969 18.623c-2.204-1.979-5.354-3.036-9.446-3.171-4.588.315-8.412 3.644-11.471 9.986v41.496h-18.893V36.781l18.893-2.023v7.489zM288.9 78.953V34.825h18.894V96.9c0 9.447-2.925 17.342-8.771 23.684-5.849 6.344-12.82 9.693-20.918 10.055l-4.048.404c-9.446-.27-17.994-4.004-25.641-11.201l8.771-10.121c5.398 4.049 10.503 6.299 15.317 6.748 5.847 0 10.042-1.463 12.584-4.385 2.54-2.926 3.812-7.086 3.812-12.484v-3.441c-4.769 4.096-10.279 6.141-16.531 6.141-8.547 0-15.069-2.586-19.567-7.76-4.498-5.172-6.747-11.133-6.747-17.881V34.825h18.893v37.111c0 4.498 1.124 7.985 3.374 10.458 2.249 2.475 5.645 3.779 10.188 3.914 3.958-.271 7.422-2.722 10.39-7.355z"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#d9a22e","d":"M463.46 1.088V40.29c3.148-3.193 8.097-5.015 14.845-5.465 10.346 0 18.555 3.373 24.628 10.121 6.072 6.747 9.109 14.62 9.109 23.616s-3.037 16.867-9.109 23.615c-6.073 6.748-14.282 10.121-24.628 10.121-4.858 0-9.808-1.799-14.845-5.398v5.398h-18.893V1.158l18.893-.067zm14.17 85.691c11.695-.449 17.768-6.971 18.218-19.566-1.35-10.346-7.422-15.946-18.218-16.802-8.548 1.306-13.271 5.735-14.17 13.293v10.931c.899 6.748 5.622 10.795 14.17 12.144zM560.46 78.953V34.825h18.893V96.9c0 9.447-2.925 17.342-8.771 23.684-5.849 6.344-12.82 9.693-20.917 10.055l-4.049.404c-9.446-.27-17.993-4.004-25.641-11.201l8.772-10.121c5.397 4.049 10.502 6.299 15.316 6.748 5.847 0 10.042-1.463 12.584-4.385 2.541-2.926 3.812-7.086 3.812-12.484v-3.441c-4.769 4.096-10.279 6.141-16.531 6.141-8.548 0-15.07-2.586-19.568-7.76-4.498-5.172-6.747-11.133-6.747-17.881V34.825h18.893v37.111c0 4.498 1.124 7.985 3.374 10.458 2.249 2.475 5.645 3.779 10.188 3.914 3.958-.271 7.423-2.722 10.392-7.355zM618.33 102.3c-7.647 0-13.721-2.135-18.218-6.41-4.499-4.273-6.748-9.783-6.748-16.531V50.143h-10.121V34.894h10.121V16.607l18.961-2.024v20.311h10.121v15.249h-10.121V76.66c0 3.6.752 6.131 2.26 7.592 1.507 1.463 3.452 2.193 5.837 2.193.719 0 2.405-.293 5.061-.877l3.98 13.562c-3.238 2.113-6.949 3.17-11.133 3.17zM630.44 68.562c0-9.896 3.148-17.993 9.447-24.291 6.297-6.298 14.394-9.446 24.29-9.446s17.769 3.148 23.616 9.446 8.772 14.396 8.772 24.291v6.747h-46.558c.449 3.599 2.024 6.409 4.723 8.435 2.699 2.023 5.848 3.035 9.446 3.035 6.298 0 11.92-1.797 16.869-5.396l10.796 10.795c-4.949 6.748-14.17 10.121-27.665 10.121-9.896 0-17.993-3.148-24.29-9.445-6.297-6.299-9.446-14.395-9.446-24.292zm43.185-15.181c-2.699-2.024-5.849-3.037-9.447-3.037s-6.747 1.013-9.446 3.037c-2.698 2.023-4.048 4.836-4.048 8.434h26.989c0-3.598-1.35-6.411-4.048-8.434zM742.63 36.714c3.508 1.53 6.791 3.802 9.851 6.815l-10.525 11.875c-3.06-3.644-6.883-5.465-11.471-5.465-4.544 0-7.581.843-9.109 2.53-1.53 1.687-1.53 3.217 0 4.588 1.528 1.373 4.565 2.509 9.109 3.407 6.702.631 12.189 2.543 16.464 5.736 4.272 3.194 6.409 8.749 6.409 16.666 0 6.387-2.52 11.336-7.557 14.844-5.038 3.508-10.909 5.264-17.611 5.264-6.388 0-11.706-.912-15.957-2.732-4.251-1.822-7.906-4.262-10.965-7.322l10.458-11.809c3.059 3.645 7.805 5.76 14.237 6.344 5.173 0 8.513-.844 10.021-2.531 1.507-1.686 1.73-3.373.675-5.061-1.058-1.686-4.622-2.822-10.695-3.406-5.488-.63-10.516-2.316-15.08-5.061-4.566-2.743-6.849-7.917-6.849-15.52 0-6.972 2.598-12.291 7.793-15.958 5.195-3.665 10.537-5.499 16.025-5.499 6.342.001 11.268.767 14.777 2.295z"}})]),_vm._v(" "),_c('path',{attrs:{"fill":"#d9a22e","d":"M429.74 32.746c0 29.939-24.383 98.289-54.463 98.289-30.076 0-54.461-68.35-54.461-98.289C320.816 2.805 345.201 0 375.277 0c30.08 0 54.463 2.805 54.463 32.746m-62.626 13.147l-23.659.936 18.588 14.604-6.417 22.689 19.693-13.087 19.694 13.087-6.415-22.69 18.588-14.604-23.66-.936-8.206-22.111-8.206 22.112z"}})])])])])])],1)}
var App_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-sm font-semibold leading-none",staticStyle:{"color":"#d9a22e"}},[_vm._v("\n          Powered By "),_c('span',{staticClass:"sr-only"},[_vm._v("Angry Bytes")])])}]
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("+6Bu");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-invisible-recaptcha/src/InvisibleRecaptcha.vue
//
//
//
//
//
//
//

/* harmony default export */ var InvisibleRecaptcha = ({
	props: {
		sitekey: {
			type: String,
			required: true
		},

		badge: {
			type: String,
			required: false,
			default: 'bottomright'
		},

		theme: {
			type: String,
			required: false,
			default: 'dark'
		},

		validate: {
			type: Function,
			required: false
		},

		callback: {
			type: Function,
			required: true
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		},

		id: {
			type: String,
			required: false
		},

		reference: {
			type: String,
			required: false
		},

		type: {
			type: String,
			required: false,
			default: 'submit'
		}
	},

	data: function data() {
		return {
			widgetId: false,
			loaded: false
		};
	},

	methods: {
		render: function render() {
			var _this = this;

			this.widgetId = grecaptcha.render(this.recaptchaId, {
				sitekey: this.sitekey,
				size: 'invisible',
				badge: this.badge,
				theme: this.theme,
				callback: function callback(token) {
					_this.callback(token);
					grecaptcha.reset(_this.widgetId);
				}
			});
			this.loaded = true;
		},

		renderWait: function renderWait() {
			var self = this;
			setTimeout(function () {
				if (typeof grecaptcha !== 'undefined' && grecaptcha.render) self.render();else self.renderWait();
			}, 200);
		},

		click: function click() {
			if (!this.validate || this.validate && this.validate() !== false) grecaptcha.execute();
		}
	},

	computed: {
		computedClass: function computedClass() {
			var classArray = this.class ? this.class.split(' ') : [];

			if (this.value) {
				classArray.push('invisible-recaptcha');
			}

			return classArray;
		},
		recaptchaId: function recaptchaId() {
			return 'vue-invisible-recaptcha-' + this._uid;
		}
	},

	mounted: function mounted() {
		if (typeof grecaptcha === 'undefined') {
			var script = document.createElement('script');
			script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
			script.onload = this.renderWait;

			document.head.appendChild(script);
		} else this.render();
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac06296","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-invisible-recaptcha/src/InvisibleRecaptcha.vue
var InvisibleRecaptcha_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:_vm.reference,class:_vm.computedClass,attrs:{"id":_vm.id,"type":_vm.type,"disabled":!_vm.loaded || _vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('div',{attrs:{"id":_vm.recaptchaId,"data-size":"invisible"}}),_vm._v(" "),_vm._t("default")],2)}
var InvisibleRecaptcha_staticRenderFns = []
var InvisibleRecaptcha_esExports = { render: InvisibleRecaptcha_render, staticRenderFns: InvisibleRecaptcha_staticRenderFns }
/* harmony default export */ var src_InvisibleRecaptcha = (InvisibleRecaptcha_esExports);
// CONCATENATED MODULE: ./node_modules/vue-invisible-recaptcha/src/InvisibleRecaptcha.vue
var InvisibleRecaptcha_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var InvisibleRecaptcha___vue_template_functional__ = false
/* styles */
var InvisibleRecaptcha___vue_styles__ = null
/* scopeId */
var InvisibleRecaptcha___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var InvisibleRecaptcha___vue_module_identifier__ = null
var InvisibleRecaptcha_Component = InvisibleRecaptcha_normalizeComponent(
  InvisibleRecaptcha,
  src_InvisibleRecaptcha,
  InvisibleRecaptcha___vue_template_functional__,
  InvisibleRecaptcha___vue_styles__,
  InvisibleRecaptcha___vue_scopeId__,
  InvisibleRecaptcha___vue_module_identifier__
)

/* harmony default export */ var vue_invisible_recaptcha_src_InvisibleRecaptcha = (InvisibleRecaptcha_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SuggestionForm.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var captchaSiteKey = "6Ld0yIAqAAAAABwErJQr17140jjgL88qILgeZ1jI";

/* harmony default export */ var SuggestionForm = ({
  name: 'SuggestionForm',
  components: {
    'invisible-recaptcha': vue_invisible_recaptcha_src_InvisibleRecaptcha
  },

  data: function data() {
    return {
      suggestionItems: {},
      hasInvalidEmail: false,
      didNotAgree: false,
      voteSent: false,
      agreed: false,
      sending: false,
      galaOptIn: false,
      keepUpToDate: true,
      email: '',
      phone: '',
      captchaSiteKey: captchaSiteKey,
      viewTerms: false
    };
  },


  computed: {
    categories: function categories() {
      return this.$store.state.categories;
    },
    round: function round() {
      return this.$store.state.rounds[0];
    },
    selectedSuggestions: function selectedSuggestions() {
      var selected = this.$store.state.selected.filter(function (selected) {
        return selected.suggestionName.length > 0;
      });

      return selected.map(function (_ref) {
        var suggestionName = _ref.suggestionName,
            suggestionStation = _ref.suggestionStation,
            obj = objectWithoutProperties_default()(_ref, ['suggestionName', 'suggestionStation']);

        return extends_default()({}, obj, {
          name: suggestionName,
          secondary_name: suggestionStation || '-'
        });
      });
    },
    allowSuggestions: function allowSuggestions() {
      return this.$store.state.allowSuggestions;
    },
    emptySuggestions: function emptySuggestions() {
      if (this.suggestionItems && keys_default()(this.suggestionItems).length === 9) {
        return values_default()(this.suggestionItems).some(function (value) {
          return value === '';
        });
      } else {
        return true;
      }
    }
  },

  methods: {
    isValidEmail: function isValidEmail() {
      return this.$refs.emailInput.validity.valid;
    },
    isIncomplete: function isIncomplete() {
      return this.agreed === false || this.isValidEmail() === false;
    },
    validate: function validate() {
      return this.isIncomplete() === false;
    },
    submit: function submit(captchaHash) {
      var _this = this;

      entries_default()(this.suggestionItems).map(function (_ref2) {
        var _ref3 = slicedToArray_default()(_ref2, 2),
            categoryId = _ref3[0],
            suggestionName = _ref3[1];

        categoryId = Number(categoryId);
        _this.$store.dispatch('addSuggestion', {
          categoryId: categoryId,
          suggestionName: suggestionName
        });
      });

      if (this.isIncomplete()) {
        this.hasInvalidEmail = this.isValidEmail() === false;
        this.didNotAgree = this.agreed === false;
        return;
      }

      var round = this.$store.state.rounds[0];
      var data = {
        captchaHash: captchaHash,
        email: this.email,
        roundId: round.id,
        extraFields: {
          keepUpToDate: this.keepUpToDate,
          galaOptIn: this.galaOptIn,
          phone: this.phone
        }
      };

      data.suggestions = this.selectedSuggestions;
      this.sending = true;
      request_post('voting/vote', {
        data: stringify_default()(data)
      }).then(function (response) {
        if (response.ok) {
          response.json().then(function (_ref4) {
            var data = _ref4.data;

            if (data.saved) {
              _this.voteSent = true;
              _this.$store.dispatch('clearSelected');
            } else {
              _this.hasVotingError = true;
            }
          });
        } else {
          _this.hasVotingError = true;
        }

        _this.sending = false;
      }).catch(function () {
        _this.hasVotingError = true;
        _this.sending = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19d79a8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SuggestionForm.vue
var SuggestionForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.voteSent)?[_c('h1',{staticClass:"title"},[_vm._v("Bijna klaar...")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]:[_c('form',{staticClass:"suggestion__form"},[_c('p',{staticClass:"mb__md",domProps:{"innerHTML":_vm._s(_vm.round.description)}}),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('div',{key:category.id,staticClass:"suggestion__form__input__section"},[_c('div',{staticClass:"suggestion__form__input__section__container"},[_c('strong',{staticClass:"suggestion__form__label"},[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('div',{staticClass:"form__field my__md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.suggestionItems[category.id]),expression:"suggestionItems[category.id]"}],staticClass:"form__input",attrs:{"type":"text","placeholder":category.placeholder || 'Naam of programma'},domProps:{"value":(_vm.suggestionItems[category.id])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.suggestionItems, category.id, $event.target.value)}}})])])])}),_vm._v(" "),_c('div',{staticClass:"suggestion__form__input__section"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"emailInput",staticClass:"form__input",attrs:{"type":"email","required":"","placeholder":"E-mailadres *","disabled":_vm.sending,"id":"form__field_email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.hasInvalidEmail)?_c('p',{staticClass:"text--error"},[_vm._v("Vul een geldig e-mailadres in")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"suggestion__form__input__section"},[_c('div',{staticClass:"form__checkbox mt__sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agreed),expression:"agreed"}],attrs:{"type":"checkbox","required":"","id":"form__field_conditions","disabled":_vm.sending},domProps:{"checked":Array.isArray(_vm.agreed)?_vm._i(_vm.agreed,null)>-1:(_vm.agreed)},on:{"change":function($event){var $$a=_vm.agreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.agreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.agreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.agreed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form__label",attrs:{"for":"form__field_conditions"}},[_vm._v("\n            Ik ga akkoord met de\n            "),_c('a',{staticClass:"link-hover",attrs:{"target":"_blank","href":"https://www.dutchrealityawards.nl/algemene-voorwaarden"},on:{"click":function($event){$event.preventDefault();_vm.viewTerms = true}}},[_vm._v("\n              voorwaarden\n            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewTerms),expression:"viewTerms"}],staticClass:"overlay",class:{ 'overlay--visible': _vm.viewTerms },on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.viewTerms = false}}},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__head"},[_c('h2',[_vm._v("Voorwaarden")]),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.viewTerms = false}}},[_vm._v("Sluiten")])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),(_vm.didNotAgree)?_c('p',{staticClass:"text--error"},[_vm._v("U moet nog akkoord gaan met voorwaarden")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form__field"},[_c('invisible-recaptcha',{staticClass:"button button--fullwidth my__md",attrs:{"sitekey":_vm.captchaSiteKey,"validate":_vm.validate,"callback":_vm.submit,"type":"submit","disabled":_vm.sending || _vm.isIncomplete() || this.emptySuggestions}},[_vm._v("\n          Inzenden\n        ")])],1),_vm._v(" "),_vm._m(3)],2)]],2)}
var SuggestionForm_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"html"},[_c('p',[_c('strong',{staticClass:"text--accent"},[_vm._v("Check je mailbox")]),_vm._v(" voor een bevestigingsmail en klik daarin op\n          de link om jouw stem definitief te maken. Doe je dat niet, dan kunnen we jouw stem helaas niet\n          meetellen.\n        ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Geen mail ontvangen? Kijk dan even in je spam folder.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html html--centered"},[_c('a',{staticClass:"button",attrs:{"href":"/"}},[_vm._v(" Naar de homepage ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__body"},[_c('p',[_vm._v("Er zijn geen algemene voorwaarden ingevuld.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"#faf9f6","text-align":"left"}},[_c('small',{staticStyle:{"color":"#faf9f6"}},[_vm._v("\n            Velden met een * zijn verplicht. Het is mogelijk om vaker te stemmen per e-mailadres, maar de reeds uitgebrachte stem wordt dan automatisch overschreven door de nieuwe stem.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Reality-tv leeft als nooit tevoren in Nederland. Met een keur aan spraakmakende programma’s, kleurrijke kandidaten en onvergetelijke tv-momenten, is het tijd om de sterren van het genre te eren. Je mag zelf bepalen wie dit jaar kans moet maken op de felbegeerde Dutch Reality Award. Je kunt je favoriet nu doorgeven. Mocht je nog niet weten op wie/wat je wilt stemmen – is stemmen hier correct? Want je kunt nog niet stemmen he? Misschien oplossen met: kun je nog wat inspiratie gebruiken? Hieronder een aantal talenten, hoogtepunten en programma’s! Laat ons je dan hieronder inspireren.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("De strijd om de titel Reality King is ongekend spannend. Wie mag zich straks dé Reality King van Nederland noemen? Wie is jouw favoriet? Geef het hierboven door.")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("Chicco uit Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Diederik uit De Bondgenoten")]),_vm._v(" "),_c('li',[_vm._v("Faisel uit onder meer House of Villains, Hakken over de Sloot en Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Frans Bauer")]),_vm._v(" "),_c('li',[_vm._v("Gerard Joling")]),_vm._v(" "),_c('li',[_vm._v("Henk van Ex On The Beach")]),_vm._v(" "),_c('li',[_vm._v("Jay Lopez uit Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("Jay Zwarts uit Temptation Island en Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Lil Kleine")]),_vm._v(" "),_c('li',[_vm._v("Maarten Blom uit Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("Marco Verstappen uit Beauty and the Geek en Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Mart uit Wakker in Paraguay")]),_vm._v(" "),_c('li',[_vm._v("Martien Meiland")]),_vm._v(" "),_c('li',[_vm._v("Nick van Ex On The Beach")]),_vm._v(" "),_c('li',[_vm._v("Oos Keskbeke uit De Augurkenkoning")]),_vm._v(" "),_c('li',[_vm._v("René Bogaart uit De Bogaartjes")]),_vm._v(" "),_c('li',[_vm._v("Roland uit De Bondgenoten")]),_vm._v(" "),_c('li',[_vm._v("Ron Hauser uit Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Timothy uit B&B")]),_vm._v(" "),_c('li',[_vm._v("Tobias Camman uit Het Perfecte Plaatje Op Reis in Vietnam")]),_vm._v(" "),_c('li',[_vm._v("Tom de Koning van Ticket to the Tribes")]),_vm._v(" "),_c('li',[_vm._v("Wout Tielemans uit Dropout Resort")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Bij de dames is het minstens zo spannend. Zij strijden o.a. om de titel Reality Queen, maar kunnen natuurlijk ook kans maken als onderdeel van jouw favoriete programma of Reality Hoogtepunt! . Wie steelt dit jaar de show? Wie is jouw favoriet? Geef het hierboven door.")]),_vm._v(" "),_c('p',[_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("Anouk uit De Bondgenoten")]),_vm._v(" "),_c('li',[_vm._v("Caroline uit B&B")]),_vm._v(" "),_c('li',[_vm._v("Charlotte Fix van Ex On The Beach: Double Dutch en Paradise Hotel")]),_vm._v(" "),_c('li',[_vm._v("Corrina Kouwen")]),_vm._v(" "),_c('li',[_vm._v("de Urker tweeling (Gerda en Mathilde) uit Echte Meisjes in de Jungle: Familie Editie")]),_vm._v(" "),_c('li',[_vm._v("Deborah van Lingen uit Hakken over de Sloot")]),_vm._v(" "),_c('li',[_vm._v("Demi van Ex On The Beach: Double Dutch")]),_vm._v(" "),_c('li',[_vm._v("Djamila Celine van The Real Housewives of Amsterdam")]),_vm._v(" "),_c('li',[_vm._v("Erica Renkema")]),_vm._v(" "),_c('li',[_vm._v("Harleya la Reine uit Hakken over de Sloot en Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Joke uit Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Josée Bronk van Schiphol Airport")]),_vm._v(" "),_c('li',[_vm._v("Kenzy uit Dames in de Dop")]),_vm._v(" "),_c('li',[_vm._v("Lisa uit Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Louisa Janssen uit Echte Meisjes")]),_vm._v(" "),_c('li',[_vm._v("Malindy Scheerhoorn uit Grote Gezinnen, Grote Vakanties")]),_vm._v(" "),_c('li',[_vm._v("Marijn Kuipers")]),_vm._v(" "),_c('li',[_vm._v("Mariska Bauer")]),_vm._v(" "),_c('li',[_vm._v("Marjan Strijbosch van The Real Housewives van het Zuiden")]),_vm._v(" "),_c('li',[_vm._v("Maxime Meiland")]),_vm._v(" "),_c('li',[_vm._v("Michella Kox uit A.S.S./House of Villains")]),_vm._v(" "),_c('li',[_vm._v("Monique Hansler uit De Hanslers")]),_vm._v(" "),_c('li',[_vm._v("Patty Brard uit A Beautiful Mess")]),_vm._v(" "),_c('li',[_vm._v("Sabrina Verhoef uit Grote Gezinnen, Grote Vakanties")]),_vm._v(" "),_c('li',[_vm._v("Sandra Bogaart van De Bogaartjes")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Vers bloed zorgt voor nieuwe energie in de Nederlandse reality wereld. …kunnen allemaal kans maken op dé doorbraak van het jaar. Elk van hen wist het afgelopen jaar het publiek te verrassen en jij bepaalt jouw favoriet. Heb je een andere keuze? Dat kan ook. Vult het hierboven in!")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("Caroline uit B&B")]),_vm._v(" "),_c('li',[_vm._v("De familie Bal uit Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("De familie Bogaart van De Bogaartjes")]),_vm._v(" "),_c('li',[_vm._v("Domenik Romano uit Married at First Sight")]),_vm._v(" "),_c('li',[_vm._v("Harleya la Reine uit Hakken over de Sloot")]),_vm._v(" "),_c('li',[_vm._v("Kim Weber uit Echte Reizigers Vrouwen")]),_vm._v(" "),_c('li',[_vm._v("Leslie de Ruiter uit Million Dollar Listing")]),_vm._v(" "),_c('li',[_vm._v("Lilian Dziedzic van The Real Housewives of Amsterdam")]),_vm._v(" "),_c('li',[_vm._v("Luca Diez uit Hakken over de Sloot S2")]),_vm._v(" "),_c('li',[_vm._v("Margretha uit De verloskundigen")]),_vm._v(" "),_c('li',[_vm._v("Maurice uit Rutger en de uitkeringstrekkers op vakantie")]),_vm._v(" "),_c('li',[_vm._v("Mitchell van Genechten uit Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Nino van der Meijde uit Andy & Melisa")]),_vm._v(" "),_c('li',[_vm._v("Nova Jansen uit Dropout Resort")]),_vm._v(" "),_c('li',[_vm._v("Rian Donders van Ticket to the Tribes")]),_vm._v(" "),_c('li',[_vm._v("Ron Hauser uit Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Timothy uit B&B Vol Liefde")]),_vm._v(" "),_c('li',[_vm._v("Tom de Koning van Ticket to the Tribes")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Het afgelopen jaar leverde weer talloze legendarische reality momenten op. Elk moment bracht gespreksstof en spektakel in de huiskamer. Welk moment is jouw favoriet? Geef het hierboven door.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Dit jaar hebben we wederom drie categorieën voor Beste Reality Programma. Namelijk Love/ Dating, Survival/Adventure/Competitie en Real Life.")]),_vm._v(" "),_c('p',[_vm._v("Hieronder een kort overzicht van de eventuele programma’s die kans maken. Dit is een inspiratielijst. Er zijn er zeker nog veel meer maar die je zelf mag invullen en bepalen:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Het gaat bij de Dutch Reality Awards om Nederlandse realitysterren/realityprogramma’s/momenten/doorbraak die tussen 1 december 2025 en 20 oktober 2026 op televisie of streamingdiensten te zien zijn.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("Arie die zijn tanden heeft laten bleken en daarmee het hart van Caroline heeft veroverd in B&B")]),_vm._v(" "),_c('li',[_vm._v("Bakje kwark in het zwembad van Charlotte en Levinio bij Ex On The Beach: Double Dutch")]),_vm._v(" "),_c('li',[_vm._v("de allereerste ‘nee’ in Married at First Sight")]),_vm._v(" "),_c('li',[_vm._v("de beschuldiging van Roland aan het adres van Salar in De Bondgenoten")]),_vm._v(" "),_c('li',[_vm._v("de eerste mannenseks in Ex on the Beach")]),_vm._v(" "),_c('li',[_vm._v("De gehele reünie van B&B Vol Liefde 2026")]),_vm._v(" "),_c('li',[_vm._v("de hernieuwde vriendschap tussen Louisa en Michella")]),_vm._v(" "),_c('li',[_vm._v("de onthulling rond het dubbelleven van Marijn Kuipers")]),_vm._v(" "),_c('li',[_vm._v("de opvallende ‘Andrew Tate’ van First Dates")]),_vm._v(" "),_c('li',[_vm._v("de ruzie tussen Megan en Shani in A.S.S.")]),_vm._v(" "),_c('li',[_vm._v("de spraakmakende ontmoeting van Jay en Lisa in Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Demi die per ongeluk Charlotte aanvalt ipv Charlene middenin de nacht ’nee jij ja, ja jij ja, ja jij ja’ uit Ex On The Beach: Double Dutch")]),_vm._v(" "),_c('li',[_vm._v("Etiquette koning Tom geeft zijn horloge aan een Himba-lid uit Ticket to the Tribes")]),_vm._v(" "),_c('li',[_vm._v("het extreem strenge vriendje Ruben in Undercover Lover")]),_vm._v(" "),_c('li',[_vm._v("het telefoongesprek tussen Anouk en Max")]),_vm._v(" "),_c('li',[_vm._v("het uienincident van de Hanslers")]),_vm._v(" "),_c('li',[_vm._v("Joke struint over de Haagse Markt in Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Maarten & Gerdine Blom gaan naar de Apenheul, raken continu kinderen kwijt bij Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("Maarten & Gerdine Blom gaan trampoline in hun tuin plaatsen, uit Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("Michael die tijdens de reünie van B&B in tranen uitbreekt, omdat eindelijk de wereld mag weten dat hij samen met Timothy is geëindigd bij B&B")]),_vm._v(" "),_c('li',[_vm._v("Nick en Marla die op de laatste avond abrupt EOTBDD verlaten over beelden van een zoen van Nick met Jennifer (Ex On The Beach: Double Dutch)")]),_vm._v(" "),_c('li',[_vm._v("Nova Jansen die haar mobiel verliest op de waterscooter in Dropout Resort")]),_vm._v(" "),_c('li',[_vm._v("Rene verrast Sandra met 2 alpaca’s bij De Bogaartjes")]),_vm._v(" "),_c('li',[_vm._v("Rijk reageert op Ray’s comment over de taak van een vrouw in Temptation Island")]),_vm._v(" "),_c('li',[_vm._v("Maxime gooit alle remmen los de eerste avond in Undercover Lover en stort zich op zijn vrouwelijke naamgenoot in Undercover Lover")]),_vm._v(" "),_c('li',[_vm._v("Tenen likken in het zwembad van Terror Jaap en Malgosia in House of Villains")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Realityprogramma’s: Real Life, Survival/Adventure/Competitie en Love/Dating")]),_vm._v(" "),_c('p',[_vm._v("In de categorie Real Life:")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("010: De mensen die Rotterdam Kleur Geven")]),_vm._v(" "),_c('li',[_vm._v("4 Handen op 1 Buik")]),_vm._v(" "),_c('li',[_vm._v("A.S.S. – Anti Survival Show")]),_vm._v(" "),_c('li',[_vm._v("Andy & Melisa")]),_vm._v(" "),_c('li',[_vm._v("Bauers")]),_vm._v(" "),_c('li',[_vm._v("Bij ons op de Wallen")]),_vm._v(" "),_c('li',[_vm._v("Brandweer010")]),_vm._v(" "),_c('li',[_vm._v("Daar Gaan Ze Weer")]),_vm._v(" "),_c('li',[_vm._v("De Augurkenkoning")]),_vm._v(" "),_c('li',[_vm._v("De Bevers")]),_vm._v(" "),_c('li',[_vm._v("De Bogaartjes")]),_vm._v(" "),_c('li',[_vm._v("De Bondgenoten")]),_vm._v(" "),_c('li',[_vm._v("De Hanslers")]),_vm._v(" "),_c('li',[_vm._v("De Roelvinkjes")]),_vm._v(" "),_c('li',[_vm._v("Dropout Resort")]),_vm._v(" "),_c('li',[_vm._v("Echte Gooische Moeders")]),_vm._v(" "),_c('li',[_vm._v("Echte Reizigers Vrouwen")]),_vm._v(" "),_c('li',[_vm._v("Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Only Joling")]),_vm._v(" "),_c('li',[_vm._v("Rutger en de uitkeringstrekkers op vakantie")]),_vm._v(" "),_c('li',[_vm._v("Schiphol Airport")]),_vm._v(" "),_c('li',[_vm._v("The Real Housewives of Amsterdam")]),_vm._v(" "),_c('li',[_vm._v("The Real Housewives van het Zuiden")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("In de categorie Survival/Adventure/Competitie")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("De Slechtste Chauffeur van Nederland")]),_vm._v(" "),_c('li',[_vm._v("De Verraders")]),_vm._v(" "),_c('li',[_vm._v("Dropout Resort")]),_vm._v(" "),_c('li',[_vm._v("Echte Jongens op Safari")]),_vm._v(" "),_c('li',[_vm._v("Echte Meisjes in de Jungle: Familie Editie")]),_vm._v(" "),_c('li',[_vm._v("Expeditie Robinson")]),_vm._v(" "),_c('li',[_vm._v("Football Island")]),_vm._v(" "),_c('li',[_vm._v("Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Hakken over de Sloot")]),_vm._v(" "),_c('li',[_vm._v("Het Perfecte Plaatje Op Reis in Vietnam")]),_vm._v(" "),_c('li',[_vm._v("House of Villains")]),_vm._v(" "),_c('li',[_vm._v("Jachtseizoen: Most Wanted")]),_vm._v(" "),_c('li',[_vm._v("NPO Start-editie van Wie is de Mol?")]),_vm._v(" "),_c('li',[_vm._v("Pandora")]),_vm._v(" "),_c('li',[_vm._v("So You Think You Can Dance")]),_vm._v(" "),_c('li',[_vm._v("Ticket to the Tribes")]),_vm._v(" "),_c('li',[_vm._v("Watch Your Back")]),_vm._v(" "),_c('li',[_vm._v("Wolven")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("In de categorie Love/Dating")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("B&B Vol Liefde")]),_vm._v(" "),_c('li',[_vm._v("Beauty and the Geek")]),_vm._v(" "),_c('li',[_vm._v("Boer Zoekt Vrouw")]),_vm._v(" "),_c('li',[_vm._v("Daten in het dorp op Texel")]),_vm._v(" "),_c('li',[_vm._v("De Bachelorette")]),_vm._v(" "),_c('li',[_vm._v("Ex On The Beach: Double Dutch")]),_vm._v(" "),_c('li',[_vm._v("First Dates")]),_vm._v(" "),_c('li',[_vm._v("Married at First Sight")]),_vm._v(" "),_c('li',[_vm._v("Onderweg naar liefde")]),_vm._v(" "),_c('li',[_vm._v("Paradise Hotel")]),_vm._v(" "),_c('li',[_vm._v("Temptation Island")]),_vm._v(" "),_c('li',[_vm._v("Undercover Lover")]),_vm._v(" "),_c('li',[_vm._v("Winter Vol Liefde")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Beste Reality Zender/Streamer")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("NPO Start")]),_vm._v(" "),_c('li',[_vm._v("Prime Video")]),_vm._v(" "),_c('li',[_vm._v("Videoland")]),_vm._v(" "),_c('li',[_vm._v("KIJK")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Beste Reality Podcast")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("Reality Check")]),_vm._v(" "),_c('li',[_vm._v("Patrick & Eline: Dit Moet Je Zien")]),_vm._v(" "),_c('li',[_vm._v("B&B Vol Liefde – De Nabeschouwing")]),_vm._v(" "),_c('li',[_vm._v("Tina FM")]),_vm._v(" "),_c('li',[_vm._v("Nick Eshuis (Macdate)")]),_vm._v(" "),_c('li',[_vm._v("MAFS-kets Vol Liefde")]),_vm._v(" "),_c('li',[_vm._v("AfterTalk")]),_vm._v(" "),_c('li',[_vm._v("Praat mee over B&B")])])])}]
var SuggestionForm_esExports = { render: SuggestionForm_render, staticRenderFns: SuggestionForm_staticRenderFns }
/* harmony default export */ var components_SuggestionForm = (SuggestionForm_esExports);
// CONCATENATED MODULE: ./src/components/SuggestionForm.vue
var SuggestionForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SuggestionForm___vue_template_functional__ = false
/* styles */
var SuggestionForm___vue_styles__ = null
/* scopeId */
var SuggestionForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SuggestionForm___vue_module_identifier__ = null
var SuggestionForm_Component = SuggestionForm_normalizeComponent(
  SuggestionForm,
  components_SuggestionForm,
  SuggestionForm___vue_template_functional__,
  SuggestionForm___vue_styles__,
  SuggestionForm___vue_scopeId__,
  SuggestionForm___vue_module_identifier__
)

/* harmony default export */ var src_components_SuggestionForm = (SuggestionForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Home = ({
  name: 'Home',

  components: {
    SuggestionForm: src_components_SuggestionForm,
    tabs: src_components_Tabs
  },

  computed: {
    rounds: function rounds() {
      return this.$store.state.rounds;
    },
    hasRound: function hasRound() {
      return this.rounds.length;
    },
    round: function round() {
      return this.rounds[0];
    },
    categories: function categories() {
      return this.$store.state.categories;
    },
    category: function category() {
      return this.categories[0];
    },
    failed: function failed() {
      return this.$store.state.failedFetch;
    },
    hasSingleCategory: function hasSingleCategory() {
      return this.categories.length === 1;
    },
    styles: function styles() {
      return this.hasRound && this.round.image ? {
        backgroundImage: 'url(' + this.round.image + ')'
      } : {};
    }
  },
  methods: {
    isFirstRound: firstRound,
    urlForCategory: function urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f248d116","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.hasRound)?[(_vm.isFirstRound())?_c('SuggestionForm'):[_c('tabs'),_vm._v(" "),_c('div',{staticClass:"html",domProps:{"innerHTML":_vm._s(_vm.round.description)}}),_vm._v(" "),(_vm.categories.length > 0)?_c('router-link',{staticClass:"button",attrs:{"to":_vm.urlForCategory(_vm.categories[0])}},[_vm._v("\n        Start met stemmen\n      ")]):_vm._e()]]:(_vm.failed)?_c('p',[_vm._v("Er is op het moment geen actieve stem ronde.")]):_c('p',[_vm._v("Het is momenteel niet mogelijk om te stemmen.")])],2)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var components_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = null
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Submit.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var Submit_captchaSiteKey = "6Ld0yIAqAAAAABwErJQr17140jjgL88qILgeZ1jI";

/* harmony default export */ var Submit = ({
  name: 'Submit',

  components: {
    'invisible-recaptcha': vue_invisible_recaptcha_src_InvisibleRecaptcha,
    selection: src_components_Selection
  },

  data: function data() {
    return {
      email: '',
      agreed: false,
      keepUpToDate: true,
      galaOptIn: false,
      phone: '',
      sending: false,
      voteSent: false,
      hasVotingError: false,
      hasInvalidEmail: false,
      didNotAgree: false,
      hasInvalidPhone: false,
      captchaSiteKey: Submit_captchaSiteKey,
      viewTerms: false
    };
  },


  computed: {
    rounds: function rounds() {
      return this.$store.state.rounds;
    },
    allowSuggestions: function allowSuggestions() {
      return this.$store.state.allowSuggestions;
    },
    selectedNominees: function selectedNominees() {
      return this.$store.state.selected.filter(function (selected) {
        return typeof selected.nomineeId !== 'undefined';
      });
    },
    selectedSuggestions: function selectedSuggestions() {
      var selected = this.$store.state.selected.filter(function (selected) {
        return typeof selected.suggestionName !== 'undefined';
      });

      return selected.map(function (_ref) {
        var suggestionName = _ref.suggestionName,
            suggestionStation = _ref.suggestionStation,
            obj = objectWithoutProperties_default()(_ref, ['suggestionName', 'suggestionStation']);

        return extends_default()({}, obj, {
          name: suggestionName,
          secondary_name: suggestionStation || '-'
        });
      });
    },
    selection: function selection() {
      return this.$store.getters.selection;
    },
    anySelected: function anySelected() {
      return this.selection.some(function (_ref2) {
        var nominee = _ref2.nominee,
            suggestion = _ref2.suggestion;
        return nominee || suggestion;
      });
    }
  },

  methods: {
    isValidEmail: function isValidEmail() {
      return this.$refs.emailInput.validity.valid;
    },
    isValidPhone: function isValidPhone() {
      return this.$refs.phoneInput ? this.$refs.phoneInput.validity.valid : false;
    },
    isIncomplete: function isIncomplete() {
      return this.agreed === false || this.isValidEmail() === false || this.galaOptIn === true && this.isValidPhone() === false;
    },
    validate: function validate() {
      return this.isIncomplete() === false;
    },
    submit: function submit(captchaHash) {
      var _this = this;

      if (this.isIncomplete()) {
        this.hasInvalidEmail = this.isValidEmail() === false;
        this.didNotAgree = this.agreed === false;
        this.hasInvalidPhone = this.isValidPhone() === false;
        return;
      }

      var round = this.rounds[0];
      var data = {
        captchaHash: captchaHash,
        email: this.email,
        roundId: round.id,
        extraFields: {
          keepUpToDate: this.keepUpToDate,
          galaOptIn: this.galaOptIn,
          phone: this.phone
        }
      };

      if (this.allowSuggestions) {
        data.suggestions = this.selectedSuggestions;
      }

      if (this.selectedNominees.length > 0) {
        data.votes = this.selectedNominees;
      }
      this.sending = true;
      request_post('voting/vote', {
        data: stringify_default()(data)
      }).then(function (response) {
        if (response.ok) {
          response.json().then(function (_ref3) {
            var data = _ref3.data;

            if (data.saved) {
              _this.voteSent = true;
              _this.$store.dispatch('clearSelected');
            } else {
              _this.hasVotingError = true;
            }
          });
        } else {
          _this.hasVotingError = true;
        }

        _this.sending = false;
      }).catch(function () {
        _this.hasVotingError = true;
        _this.sending = false;
      });
    },
    stylesForNominee: function stylesForNominee(nominee) {
      return {
        backgroundImage: 'url(' + nominee.image + ')'
      };
    },
    urlForCategory: function urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44a70826","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submit.vue
var Submit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rounds.length)?_c('div',[_c('div',{staticClass:"content"},[(_vm.voteSent)?[_c('h1',{staticClass:"title",staticStyle:{"color":"#faf9f6"}},[_vm._v("Bijna klaar...")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]:[_c('h1',{staticClass:"title",staticStyle:{"color":"#faf9f6","text-decoration":"underline"}},[_vm._v("Inzenden")]),_vm._v(" "),_c('selection'),_vm._v(" "),(_vm.anySelected)?_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"form__field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"emailInput",staticClass:"form__input",staticStyle:{"background-color":"#121212","color":"#faf9f6","border":"solid 1px #f2ad07"},attrs:{"type":"email","required":"","placeholder":"E-mailadres *","disabled":_vm.sending,"id":"form__field_email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.hasInvalidEmail)?_c('p',{staticClass:"text--error"},[_vm._v("Vul een geldig e-mailadres in")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form__checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agreed),expression:"agreed"}],attrs:{"type":"checkbox","required":"","id":"form__field_conditions","disabled":_vm.sending},domProps:{"checked":Array.isArray(_vm.agreed)?_vm._i(_vm.agreed,null)>-1:(_vm.agreed)},on:{"change":function($event){var $$a=_vm.agreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.agreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.agreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.agreed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form__label",staticStyle:{"color":"#faf9f6"},attrs:{"for":"form__field_conditions"}},[_vm._v("\n            Ik ga akkoord met de\n            "),_c('a',{staticClass:"link-hover",attrs:{"target":"_blank","href":"https://www.dutchrealityawards.nl/algemene-voorwaarden"},on:{"click":function($event){$event.preventDefault();_vm.viewTerms = true}}},[_vm._v("\n              voorwaarden\n            ")])]),_vm._v(" "),(_vm.didNotAgree)?_c('p',{staticClass:"text--error"},[_vm._v("U moet nog akkoord gaan met voorwaarden")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form__field"},[_c('invisible-recaptcha',{staticClass:"button button--fullwidth",staticStyle:{"background-color":"#d9a22e"},attrs:{"sitekey":_vm.captchaSiteKey,"validate":_vm.validate,"callback":_vm.submit,"type":"submit","disabled":_vm.sending || _vm.isIncomplete()}},[_vm._v("\n            Inzenden\n          ")])],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div')]):_c('p',{staticClass:"p--md",staticStyle:{"color":"#faf9f6"}},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Selecteer")]),_vm._v("\n        eerst een of meer genomineerden.\n      ")],1)]],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewTerms),expression:"viewTerms"}],staticClass:"overlay",class:{ 'overlay--visible': _vm.viewTerms },on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.viewTerms = false}}},[_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__head"},[_c('h2',[_vm._v("Voorwaarden")]),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.viewTerms = false}}},[_vm._v("Sluiten")])]),_vm._v(" "),_vm._m(3)])])]):_c('p',{staticClass:"p--md"},[_vm._v("Er kan momenteel niet gestemd worden.")])}
var Submit_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"html"},[_c('p',[_c('strong',{staticClass:"text--accent"},[_vm._v("Check je mailbox")]),_vm._v(" voor een bevestigingsmail en klik daarin\n            op de link om jouw stem definitief te maken. Doe je dat niet, dan kunnen we jouw stem helaas\n            niet meetellen.\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Geen mail ontvangen? Kijk dan even in je spam folder.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html html--centered"},[_c('a',{staticClass:"button",attrs:{"href":"/"}},[_vm._v(" Naar de homepage ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"#faf9f6"}},[_c('small',{staticStyle:{"color":"#faf9f6"}},[_vm._v("\n            Velden met een * zijn verplicht. Het is mogelijk om vaker te stemmen per e-mailadres, maar de\n            reeds uitgebrachte stem wordt dan automatisch overschreven door de nieuwe stem.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Reality-tv leeft als nooit tevoren in Nederland. Met een keur aan spraakmakende programma’s, kleurrijke kandidaten en onvergetelijke tv-momenten, is het tijd om de sterren van het genre te eren. Je mag zelf bepalen wie dit jaar kans moet maken op de felbegeerde Dutch Reality Award. Je kunt je favoriet nu doorgeven. Mocht je nog niet weten op wie/wat je wilt stemmen – is stemmen hier correct? Want je kunt nog niet stemmen he? Misschien oplossen met: kun je nog wat inspiratie gebruiken? Hieronder een aantal talenten, hoogtepunten en programma’s!  Laat ons je dan hieronder inspireren. ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("De strijd om de titel Reality King is ongekend spannend. Wie mag zich straks dé Reality King van Nederland noemen? Wie is jouw favoriet? Geef het hierboven door.")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("Chicco uit Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Diederik uit De Bondgenoten")]),_vm._v(" "),_c('li',[_vm._v("Faisel uit onder meer House of Villains, Hakken over de Sloot en Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Frans Bauer")]),_vm._v(" "),_c('li',[_vm._v("Gerard Joling")]),_vm._v(" "),_c('li',[_vm._v("Henk van Ex On The Beach")]),_vm._v(" "),_c('li',[_vm._v("Jay Lopez uit Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("Jay Zwarts uit Temptation Island en Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Lil Kleine")]),_vm._v(" "),_c('li',[_vm._v("Maarten Blom uit Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("Marco Verstappen uit Beauty and the Geek en Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Mart uit Wakker in Paraguay")]),_vm._v(" "),_c('li',[_vm._v("Martien Meiland")]),_vm._v(" "),_c('li',[_vm._v("Nick van Ex On The Beach")]),_vm._v(" "),_c('li',[_vm._v("Oos Keskbeke uit De Augurkenkoning")]),_vm._v(" "),_c('li',[_vm._v("René Bogaart uit De Bogaartjes")]),_vm._v(" "),_c('li',[_vm._v("Roland uit De Bondgenoten")]),_vm._v(" "),_c('li',[_vm._v("Ron Hauser uit Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Timothy uit B&B")]),_vm._v(" "),_c('li',[_vm._v("Tobias Camman uit Het Perfecte Plaatje Op Reis in Vietnam")]),_vm._v(" "),_c('li',[_vm._v("Tom de Koning van Ticket to the Tribes")]),_vm._v(" "),_c('li',[_vm._v("Wout Tielemans uit Dropout Resort")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Bij de dames is het minstens zo spannend. Zij strijden o.a. om de titel Reality Queen, maar kunnen natuurlijk ook kans maken als onderdeel van jouw favoriete programma of Reality Hoogtepunt! . Wie steelt dit jaar de show? Wie is jouw favoriet? Geef het hierboven door.\n          ")]),_vm._v(" "),_c('p',[_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("Anouk uit De Bondgenoten")]),_vm._v(" "),_c('li',[_vm._v("Caroline uit B&B")]),_vm._v(" "),_c('li',[_vm._v("Charlotte Fix van Ex On The Beach: Double Dutch en Paradise Hotel")]),_vm._v(" "),_c('li',[_vm._v("Corrina Kouwen")]),_vm._v(" "),_c('li',[_vm._v("de Urker tweeling (Gerda en Mathilde) uit Echte Meisjes in de Jungle: Familie Editie")]),_vm._v(" "),_c('li',[_vm._v("Deborah van Lingen uit Hakken over de Sloot")]),_vm._v(" "),_c('li',[_vm._v("Demi van Ex On The Beach: Double Dutch")]),_vm._v(" "),_c('li',[_vm._v("Djamila Celine van The Real Housewives of Amsterdam")]),_vm._v(" "),_c('li',[_vm._v("Erica Renkema")]),_vm._v(" "),_c('li',[_vm._v("Harleya la Reine uit Hakken over de Sloot en Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Joke uit Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Josée Bronk van Schiphol Airport")]),_vm._v(" "),_c('li',[_vm._v("Kenzy uit Dames in de Dop")]),_vm._v(" "),_c('li',[_vm._v("Lisa uit Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Louisa Janssen uit Echte Meisjes")]),_vm._v(" "),_c('li',[_vm._v("Malindy Scheerhoorn uit Grote Gezinnen, Grote Vakanties")]),_vm._v(" "),_c('li',[_vm._v("Marijn Kuipers")]),_vm._v(" "),_c('li',[_vm._v("Mariska Bauer")]),_vm._v(" "),_c('li',[_vm._v("Marjan Strijbosch van The Real Housewives van het Zuiden")]),_vm._v(" "),_c('li',[_vm._v("Maxime Meiland")]),_vm._v(" "),_c('li',[_vm._v("Michella Kox uit A.S.S./House of Villains")]),_vm._v(" "),_c('li',[_vm._v("Monique Hansler uit De Hanslers")]),_vm._v(" "),_c('li',[_vm._v("Patty Brard uit A Beautiful Mess")]),_vm._v(" "),_c('li',[_vm._v("Sabrina Verhoef uit Grote Gezinnen, Grote Vakanties")]),_vm._v(" "),_c('li',[_vm._v("Sandra Bogaart van De Bogaartjes")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Vers bloed zorgt voor nieuwe energie in de Nederlandse reality wereld. …kunnen allemaal kans maken op dé doorbraak van het jaar. Elk van hen wist het afgelopen jaar het publiek te verrassen en jij bepaalt jouw favoriet. Heb je een andere keuze? Dat kan ook. Vult het hierboven in!")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("Caroline uit B&B")]),_vm._v(" "),_c('li',[_vm._v("De familie Bal uit Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("De familie Bogaart van De Bogaartjes")]),_vm._v(" "),_c('li',[_vm._v("Domenik Romano uit Married at First Sight")]),_vm._v(" "),_c('li',[_vm._v("Harleya la Reine uit Hakken over de Sloot")]),_vm._v(" "),_c('li',[_vm._v("Kim Weber uit Echte Reizigers Vrouwen")]),_vm._v(" "),_c('li',[_vm._v("Leslie de Ruiter uit Million Dollar Listing")]),_vm._v(" "),_c('li',[_vm._v("Lilian Dziedzic van The Real Housewives of Amsterdam")]),_vm._v(" "),_c('li',[_vm._v("Luca Diez uit Hakken over de Sloot S2")]),_vm._v(" "),_c('li',[_vm._v("Margretha uit De verloskundigen")]),_vm._v(" "),_c('li',[_vm._v("Maurice uit Rutger en de uitkeringstrekkers op vakantie")]),_vm._v(" "),_c('li',[_vm._v("Mitchell van Genechten uit Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Nino van der Meijde uit Andy & Melisa")]),_vm._v(" "),_c('li',[_vm._v("Nova Jansen uit Dropout Resort")]),_vm._v(" "),_c('li',[_vm._v("Rian Donders van Ticket to the Tribes")]),_vm._v(" "),_c('li',[_vm._v("Ron Hauser uit Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Timothy uit B&B Vol Liefde")]),_vm._v(" "),_c('li',[_vm._v("Tom de Koning van Ticket to the Tribes")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Het afgelopen jaar leverde weer talloze legendarische reality momenten op. \n          Elk moment bracht gespreksstof en spektakel in de huiskamer. Welk moment is jouw favoriet? Geef het hierboven door.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Dit jaar hebben we wederom drie categorieën voor Beste Reality Programma. Namelijk Love/ Dating, Survival/Adventure/Competitie en Real Life.")]),_vm._v(" "),_c('p',[_vm._v("Hieronder een kort overzicht van de eventuele programma’s die kans maken. Dit is een inspiratielijst. Er zijn er zeker nog veel meer maar die je zelf mag invullen en bepalen:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Het gaat bij de Dutch Reality Awards om Nederlandse realitysterren/realityprogramma’s/momenten/doorbraak die tussen 1 december 2025 en 20 oktober 2026 op televisie of streamingdiensten te zien zijn.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("Arie die zijn tanden heeft laten bleken en daarmee het hart van Caroline heeft veroverd in B&B")]),_vm._v(" "),_c('li',[_vm._v("Bakje kwark in het zwembad van Charlotte en Levinio bij Ex On The Beach: Double Dutch")]),_vm._v(" "),_c('li',[_vm._v("de allereerste ‘nee’ in Married at First Sight")]),_vm._v(" "),_c('li',[_vm._v("de beschuldiging van Roland aan het adres van Salar in De Bondgenoten")]),_vm._v(" "),_c('li',[_vm._v("de eerste mannenseks in Ex on the Beach")]),_vm._v(" "),_c('li',[_vm._v("De gehele reünie van B&B Vol Liefde 2026")]),_vm._v(" "),_c('li',[_vm._v("de hernieuwde vriendschap tussen Louisa en Michella")]),_vm._v(" "),_c('li',[_vm._v("de onthulling rond het dubbelleven van Marijn Kuipers")]),_vm._v(" "),_c('li',[_vm._v("de opvallende ‘Andrew Tate’ van First Dates")]),_vm._v(" "),_c('li',[_vm._v("de ruzie tussen Megan en Shani in A.S.S.")]),_vm._v(" "),_c('li',[_vm._v("de spraakmakende ontmoeting van Jay en Lisa in Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Demi die per ongeluk Charlotte aanvalt ipv Charlene middenin de nacht ’nee jij ja, ja jij ja, ja jij ja’ uit Ex On The Beach: Double Dutch")]),_vm._v(" "),_c('li',[_vm._v("Etiquette koning Tom geeft zijn horloge aan een Himba-lid uit Ticket to the Tribes")]),_vm._v(" "),_c('li',[_vm._v("het extreem strenge vriendje Ruben in Undercover Lover")]),_vm._v(" "),_c('li',[_vm._v("het telefoongesprek tussen Anouk en Max")]),_vm._v(" "),_c('li',[_vm._v("het uienincident van de Hanslers")]),_vm._v(" "),_c('li',[_vm._v("Joke struint over de Haagse Markt in Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Maarten & Gerdine Blom gaan naar de Apenheul, raken continu kinderen kwijt bij Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("Maarten & Gerdine Blom gaan trampoline in hun tuin plaatsen, uit Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("Michael die tijdens de reünie van B&B in tranen uitbreekt, omdat eindelijk de wereld mag weten dat hij samen met Timothy is geëindigd bij B&B")]),_vm._v(" "),_c('li',[_vm._v("Nick en Marla die op de laatste avond abrupt EOTBDD verlaten over beelden van een zoen van Nick met Jennifer (Ex On The Beach: Double Dutch)")]),_vm._v(" "),_c('li',[_vm._v("Rene verrast Sandra met 2 alpaca’s bij De Bogaartjes")]),_vm._v(" "),_c('li',[_vm._v("Rijk reageert op Ray’s comment over de taak van een vrouw in Temptation Island")]),_vm._v(" "),_c('li',[_vm._v("Maxime gooit alle remmen los de eerste avond in Undercover Lover en stort zich op zijn vrouwelijke naamgenoot in Undercover Lover")]),_vm._v(" "),_c('li',[_vm._v("Tenen likken in het zwembad van Terror Jaap en Malgosia in House of Villains")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Realityprogramma’s: Real Life, Survival/Adventure/Competitie en Love/Dating")]),_vm._v(" "),_c('p',[_vm._v("In de categorie Real Life:")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("010: De mensen die Rotterdam Kleur Geven")]),_vm._v(" "),_c('li',[_vm._v("4 Handen op 1 Buik")]),_vm._v(" "),_c('li',[_vm._v("A.S.S. – Anti Survival Show")]),_vm._v(" "),_c('li',[_vm._v("Andy & Melisa")]),_vm._v(" "),_c('li',[_vm._v("Bauers")]),_vm._v(" "),_c('li',[_vm._v("Bij ons op de Wallen")]),_vm._v(" "),_c('li',[_vm._v("Brandweer010")]),_vm._v(" "),_c('li',[_vm._v("Daar Gaan Ze Weer")]),_vm._v(" "),_c('li',[_vm._v("De Augurkenkoning")]),_vm._v(" "),_c('li',[_vm._v("De Bevers")]),_vm._v(" "),_c('li',[_vm._v("De Bogaartjes")]),_vm._v(" "),_c('li',[_vm._v("De Bondgenoten")]),_vm._v(" "),_c('li',[_vm._v("De Hanslers")]),_vm._v(" "),_c('li',[_vm._v("De Roelvinkjes")]),_vm._v(" "),_c('li',[_vm._v("Dropout Resort")]),_vm._v(" "),_c('li',[_vm._v("Echte Gooische Moeders")]),_vm._v(" "),_c('li',[_vm._v("Echte Reizigers Vrouwen")]),_vm._v(" "),_c('li',[_vm._v("Een Huis Vol")]),_vm._v(" "),_c('li',[_vm._v("Oh oh Den Haag")]),_vm._v(" "),_c('li',[_vm._v("Only Joling")]),_vm._v(" "),_c('li',[_vm._v("Rutger en de uitkeringstrekkers op vakantie")]),_vm._v(" "),_c('li',[_vm._v("Schiphol Airport")]),_vm._v(" "),_c('li',[_vm._v("The Real Housewives of Amsterdam")]),_vm._v(" "),_c('li',[_vm._v("The Real Housewives van het Zuiden")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("In de categorie Survival/Adventure/Competitie")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("De Slechtste Chauffeur van Nederland")]),_vm._v(" "),_c('li',[_vm._v("De Verraders")]),_vm._v(" "),_c('li',[_vm._v("Dropout Resort")]),_vm._v(" "),_c('li',[_vm._v("Echte Jongens op Safari")]),_vm._v(" "),_c('li',[_vm._v("Echte Meisjes in de Jungle: Familie Editie")]),_vm._v(" "),_c('li',[_vm._v("Expeditie Robinson")]),_vm._v(" "),_c('li',[_vm._v("Football Island")]),_vm._v(" "),_c('li',[_vm._v("Good Luck Guys")]),_vm._v(" "),_c('li',[_vm._v("Hakken over de Sloot")]),_vm._v(" "),_c('li',[_vm._v("Het Perfecte Plaatje Op Reis in Vietnam")]),_vm._v(" "),_c('li',[_vm._v("House of Villains")]),_vm._v(" "),_c('li',[_vm._v("Jachtseizoen: Most Wanted")]),_vm._v(" "),_c('li',[_vm._v("NPO Start-editie van Wie is de Mol?")]),_vm._v(" "),_c('li',[_vm._v("Pandora")]),_vm._v(" "),_c('li',[_vm._v("So You Think You Can Dance")]),_vm._v(" "),_c('li',[_vm._v("Ticket to the Tribes")]),_vm._v(" "),_c('li',[_vm._v("Watch Your Back")]),_vm._v(" "),_c('li',[_vm._v("Wolven")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("In de categorie Love/Dating")]),_vm._v(" "),_c('ul',{staticStyle:{"padding-inline":"32px"}},[_c('li',[_vm._v("B&B Vol Liefde")]),_vm._v(" "),_c('li',[_vm._v("Beauty and the Geek")]),_vm._v(" "),_c('li',[_vm._v("Boer Zoekt Vrouw")]),_vm._v(" "),_c('li',[_vm._v("Daten in het dorp op Texel")]),_vm._v(" "),_c('li',[_vm._v("De Bachelorette")]),_vm._v(" "),_c('li',[_vm._v("Ex On The Beach: Double Dutch")]),_vm._v(" "),_c('li',[_vm._v("First Dates")]),_vm._v(" "),_c('li',[_vm._v("Married at First Sight")]),_vm._v(" "),_c('li',[_vm._v("Onderweg naar liefde")]),_vm._v(" "),_c('li',[_vm._v("Paradise Hotel")]),_vm._v(" "),_c('li',[_vm._v("Temptation Island")]),_vm._v(" "),_c('li',[_vm._v("Undercover Lover")]),_vm._v(" "),_c('li',[_vm._v("Winter Vol Liefde")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__body"},[_c('p',[_vm._v("Er zijn geen algemene voorwaarden ingevuld.")])])}]
var Submit_esExports = { render: Submit_render, staticRenderFns: Submit_staticRenderFns }
/* harmony default export */ var components_Submit = (Submit_esExports);
// CONCATENATED MODULE: ./src/components/Submit.vue
var Submit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Submit___vue_template_functional__ = false
/* styles */
var Submit___vue_styles__ = null
/* scopeId */
var Submit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Submit___vue_module_identifier__ = null
var Submit_Component = Submit_normalizeComponent(
  Submit,
  components_Submit,
  Submit___vue_template_functional__,
  Submit___vue_styles__,
  Submit___vue_scopeId__,
  Submit___vue_module_identifier__
)

/* harmony default export */ var src_components_Submit = (Submit_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./src/util/share.js

var target = '_blank';
var features = 'noopener,noreferrer';
var isMobile = (typeof navigator === 'undefined' ? 'undefined' : typeof_default()(navigator)) === 'object' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

var defaultUrl = document.location.origin;

function facebook(_ref) {
  var text = _ref.text,
      _ref$url = _ref.url,
      url = _ref$url === undefined ? defaultUrl : _ref$url;

  var base = 'https://facebook.com/sharer.php';
  window.open(base + '?u=' + encodeURIComponent(url) + '&quote=' + encodeURIComponent(text.replace(/\s+/, ' ')), target, features);
}

function twitter(_ref2) {
  var text = _ref2.text,
      _ref2$url = _ref2.url,
      url = _ref2$url === undefined ? defaultUrl : _ref2$url;

  var base = 'https://twitter.com/intent/tweet';
  window.open(base + '?text=' + encodeURIComponent(text.replace(/\s+/, ' ')) + '&url=' + encodeURIComponent(url), target, features);
}

function whatsapp(_ref3) {
  var text = _ref3.text,
      _ref3$url = _ref3.url,
      url = _ref3$url === undefined ? defaultUrl : _ref3$url;

  var platform = isMobile ? 'api' : 'web';
  var base = 'https://' + platform + '.whatsapp.com/send';

  window.open(base + '?text=' + encodeURIComponent(text.replace(/\s+/, ' ') + ' ' + url), target, features);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Confirm.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _process$env$FRONTEND = "https://stemmen.dutchrealityawards.nl",
    FRONTEND_DOMAIN = _process$env$FRONTEND === undefined ? document.location.origin : _process$env$FRONTEND;

/* harmony default export */ var Confirm = ({
  name: 'Confirm',
  data: function data() {
    return {
      loading: true,
      confirmed: false,
      replay: false,
      notFound: false,
      nomineeIds: [],
      votedNominees: [],
      suggestions: [],
      shareUrl: FRONTEND_DOMAIN
    };
  },

  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  methods: {
    facebook: facebook,
    twitter: twitter,
    whatsapp: whatsapp
  },
  computed: {
    loaded: function loaded() {
      return this.$store.state.loaded;
    },
    rounds: function rounds() {
      return this.$store.state.rounds;
    },
    nominees: function nominees() {
      var _this = this;

      return this.$store.state.nominees.filter(function (_ref) {
        var id = _ref.id;
        return _this.nomineeIds.includes(id);
      });
    },
    categories: function categories() {
      return this.$store.state.categories;
    },
    shareText: function shareText() {
      var nominees = this.votedNominees.map(function (_ref2) {
        var name = _ref2.name,
            hashtag = _ref2.hashtag;
        return name + (hashtag && hashtag.length ? ' (' + hashtag + ')' : '');
      });

      var sentence = [].concat(toConsumableArray_default()(nominees)).reduce(function (acc, curr, index, names) {
        if (index === 0) {
          return curr;
        }

        return index < names.length - 1 ? acc + ', ' + curr : acc + ' en ' + curr;
      }, '');

      return 'Ik heb gestemd op ' + sentence + '. Stem nu ook!';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    get('voting/vote/confirm/' + this.uuid).then(function (response) {
      if (response.ok) {
        response.json().then(function (_ref3) {
          var data = _ref3.data;
          var confirmed = data.confirmed,
              replay = data.replay,
              notFound = data.notFound,
              nominees = data.nominees,
              suggestions = data.suggestions;

          _this2.confirmed = confirmed;
          _this2.replay = replay;
          _this2.notFound = notFound;
          _this2.suggestions = suggestions;
          _this2.nomineeIds = nominees.map(Number);
          _this2.loading = false;

          get('voting/votes/' + _this2.uuid).then(function (response) {
            return response.json();
          }).then(function (_ref4) {
            var data = _ref4.data;
            var votes = data.votes;

            _this2.votedNominees = votes;
          });
        });
      } else {
        _this2.notFound = true;
        _this2.loading = false;
      }
    }).catch(function () {
      _this2.notFound = true;
      _this2.loading = false;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33132a47","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirm.vue
var Confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rounds.length)?_c('div',{staticClass:"content"},[(_vm.loading)?_c('h1',{staticClass:"title"},[_vm._v("een moment geduld alstublieft...")]):(_vm.confirmed)?[(!_vm.replay)?_c('h1',{staticClass:"title"},[_vm._v("Je stem is bevestigd!")]):_vm._e(),_vm._v(" "),(_vm.replay)?_c('h1',{staticClass:"title"},[_vm._v("Je stem was bevestigd")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card card--centered"},[(_vm.votedNominees.length)?_c('p',{staticClass:"votes"},[_vm._l((_vm.votedNominees),function(nominee){return [(nominee.type === 'dutchrealityawards_nominees')?_c('div',{staticClass:"selection__image__container"},[(nominee.url)?_c('div',{staticClass:"nomineeUrl"},[_c('a',{attrs:{"target":"_blank","href":nominee.url}},[_c('svg',{staticClass:"url__icon",attrs:{"viewBox":"0 0 256 256","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid"}},[_c('g',[_c('path',{attrs:{"d":"M127.999746,23.06353 C162.177385,23.06353 166.225393,23.1936027 179.722476,23.8094161 C192.20235,24.3789926 198.979853,26.4642218 203.490736,28.2166477 C209.464938,30.5386501 213.729395,33.3128586 218.208268,37.7917319 C222.687141,42.2706052 225.46135,46.5350617 227.782844,52.5092638 C229.535778,57.0201472 231.621007,63.7976504 232.190584,76.277016 C232.806397,89.7746075 232.93647,93.8226147 232.93647,128.000254 C232.93647,162.177893 232.806397,166.225901 232.190584,179.722984 C231.621007,192.202858 229.535778,198.980361 227.782844,203.491244 C225.46135,209.465446 222.687141,213.729903 218.208268,218.208776 C213.729395,222.687649 209.464938,225.461858 203.490736,227.783352 C198.979853,229.536286 192.20235,231.621516 179.722476,232.191092 C166.227425,232.806905 162.179418,232.936978 127.999746,232.936978 C93.8200742,232.936978 89.772067,232.806905 76.277016,232.191092 C63.7971424,231.621516 57.0196391,229.536286 52.5092638,227.783352 C46.5345536,225.461858 42.2700971,222.687649 37.7912238,218.208776 C33.3123505,213.729903 30.538142,209.465446 28.2166477,203.491244 C26.4637138,198.980361 24.3784845,192.202858 23.808908,179.723492 C23.1930946,166.225901 23.0630219,162.177893 23.0630219,128.000254 C23.0630219,93.8226147 23.1930946,89.7746075 23.808908,76.2775241 C24.3784845,63.7976504 26.4637138,57.0201472 28.2166477,52.5092638 C30.538142,46.5350617 33.3123505,42.2706052 37.7912238,37.7917319 C42.2700971,33.3128586 46.5345536,30.5386501 52.5092638,28.2166477 C57.0196391,26.4642218 63.7971424,24.3789926 76.2765079,23.8094161 C89.7740994,23.1936027 93.8221066,23.06353 127.999746,23.06353 M127.999746,0 C93.2367791,0 88.8783247,0.147348072 75.2257637,0.770274749 C61.601148,1.39218523 52.2968794,3.55566141 44.1546281,6.72008828 C35.7374966,9.99121548 28.5992446,14.3679613 21.4833489,21.483857 C14.3674532,28.5997527 9.99070739,35.7380046 6.71958019,44.1551362 C3.55515331,52.2973875 1.39167714,61.6016561 0.769766653,75.2262718 C0.146839975,88.8783247 0,93.2372872 0,128.000254 C0,162.763221 0.146839975,167.122183 0.769766653,180.774236 C1.39167714,194.398852 3.55515331,203.703121 6.71958019,211.845372 C9.99070739,220.261995 14.3674532,227.400755 21.4833489,234.516651 C28.5992446,241.632547 35.7374966,246.009293 44.1546281,249.28042 C52.2968794,252.444847 61.601148,254.608323 75.2257637,255.230233 C88.8783247,255.85316 93.2367791,256 127.999746,256 C162.762713,256 167.121675,255.85316 180.773728,255.230233 C194.398344,254.608323 203.702613,252.444847 211.844864,249.28042 C220.261995,246.009293 227.400247,241.632547 234.516143,234.516651 C241.632039,227.400755 246.008785,220.262503 249.279912,211.845372 C252.444339,203.703121 254.607815,194.398852 255.229725,180.774236 C255.852652,167.122183 256,162.763221 256,128.000254 C256,93.2372872 255.852652,88.8783247 255.229725,75.2262718 C254.607815,61.6016561 252.444339,52.2973875 249.279912,44.1551362 C246.008785,35.7380046 241.632039,28.5997527 234.516143,21.483857 C227.400247,14.3679613 220.261995,9.99121548 211.844864,6.72008828 C203.702613,3.55566141 194.398344,1.39218523 180.773728,0.770274749 C167.121675,0.147348072 162.762713,0 127.999746,0 Z M127.999746,62.2703115 C91.698262,62.2703115 62.2698034,91.69877 62.2698034,128.000254 C62.2698034,164.301738 91.698262,193.730197 127.999746,193.730197 C164.30123,193.730197 193.729689,164.301738 193.729689,128.000254 C193.729689,91.69877 164.30123,62.2703115 127.999746,62.2703115 Z M127.999746,170.667175 C104.435741,170.667175 85.3328252,151.564259 85.3328252,128.000254 C85.3328252,104.436249 104.435741,85.3333333 127.999746,85.3333333 C151.563751,85.3333333 170.666667,104.436249 170.666667,128.000254 C170.666667,151.564259 151.563751,170.667175 127.999746,170.667175 Z M211.686338,59.6734287 C211.686338,68.1566129 204.809755,75.0337031 196.326571,75.0337031 C187.843387,75.0337031 180.966297,68.1566129 180.966297,59.6734287 C180.966297,51.1902445 187.843387,44.3136624 196.326571,44.3136624 C204.809755,44.3136624 211.686338,51.1902445 211.686338,59.6734287 Z"}})])])])]):_vm._e(),_vm._v(" "),(nominee.image)?_c('img',{key:nominee.id,staticClass:"vote",attrs:{"src":nominee.image.data.src}}):_vm._e(),_vm._v(" "),_c('b',{staticStyle:{"position":"absolute","bottom":"0","right":"0","left":"0","z-index":"1"}},[_vm._v(_vm._s(nominee.name)+" ")])]):(nominee.type === 'voting_suggestions')?_c('div',{staticClass:"vote"},[_c('b',{staticStyle:{"position":"absolute","bottom":"0","right":"0","left":"0"}},[_vm._v(_vm._s(nominee.name)+" ")]),_vm._v(" "),_c('img',{attrs:{"src":"static/base_icon.png"}})]):_vm._e()]})],2):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"share"},[_c('a',{staticClass:"share__button",attrs:{"href":"https://web.whatsapp.com","rel":"noopener","target":"_blank","title":"Deel op Whatsapp"},on:{"click":function($event){$event.preventDefault();return _vm.whatsapp({ text: _vm.shareText, url: _vm.shareUrl })}}},[_c('svg',{attrs:{"viewBox":"0 0 448 512"}},[_c('path',{attrs:{"fill":"#d9a22e","d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}})])]),_vm._v(" "),_c('a',{staticClass:"share__button",attrs:{"href":"https://facebook.com","rel":"noopener","target":"_blank","title":"Deel op Facebook"},on:{"click":function($event){$event.preventDefault();return _vm.facebook({ text: _vm.shareText, url: _vm.shareUrl })}}},[_c('svg',{attrs:{"viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"#d9a22e","d":"M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"}})])]),_vm._v(" "),_c('a',{staticClass:"share__button",attrs:{"href":"https://x.com","rel":"noopener","target":"_blank","title":"Deel op X"},on:{"click":function($event){$event.preventDefault();return _vm.twitter({ text: _vm.shareText, url: _vm.shareUrl })}}},[_c('svg',{attrs:{"viewBox":"0 0 1200 1222"}},[_c('path',{attrs:{"fill":"#d9a22e","d":"M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"}})])])])])]:(_vm.notFound)?_c('div',{staticClass:"card"},[_c('p',[_vm._v("Deze bevestigings link is ongeldig.")])]):_vm._e()],2):_c('div',{staticClass:"card"},[_c('p',[_vm._v("Er kan op dit moment niet (meer) gestemd worden.")])])}
var Confirm_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html html--centered"},[_c('p',[_vm._v("Bedankt voor het stemmen!")]),_vm._v(" "),_c('p',[_vm._v("Vergeet niet om je stem te delen met je vrienden via Whatsapp, Facebook of X!")])])}]
var Confirm_esExports = { render: Confirm_render, staticRenderFns: Confirm_staticRenderFns }
/* harmony default export */ var components_Confirm = (Confirm_esExports);
// CONCATENATED MODULE: ./src/components/Confirm.vue
var Confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Confirm___vue_template_functional__ = false
/* styles */
var Confirm___vue_styles__ = null
/* scopeId */
var Confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Confirm___vue_module_identifier__ = null
var Confirm_Component = Confirm_normalizeComponent(
  Confirm,
  components_Confirm,
  Confirm___vue_template_functional__,
  Confirm___vue_styles__,
  Confirm___vue_scopeId__,
  Confirm___vue_module_identifier__
)

/* harmony default export */ var src_components_Confirm = (Confirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/QuickAdd.vue

//
//
//
//



/* harmony default export */ var QuickAdd = ({
  name: 'QuickAdd',

  props: {
    categorySlug: {
      type: String,
      required: true
    },

    nomineeSlug: {
      type: String,
      required: true
    }
  },

  mounted: function mounted() {
    var nominee = this.nominee;


    if (nominee) {
      var category = nominee.category;


      this.$store.dispatch('selectNominee', {
        categoryId: category.id,
        nomineeId: nominee.id
      });

      this.$router.push({
        name: 'category',
        params: {
          categorySlug: category.slug
        }
      });
    } else {
      this.$router.push({
        name: 'home'
      });
    }
  },


  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(['nominees']), {
    nominee: function nominee() {
      var _this = this;

      return this.nominees.find(function (nominee) {
        return nominee.slug === _this.nomineeSlug && nominee.category.slug === _this.categorySlug;
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93ed4760","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuickAdd.vue
var QuickAdd_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.nominee)?_c('div',[_vm._v("Een moment geduld aub.")]):_vm._e()}
var QuickAdd_staticRenderFns = []
var QuickAdd_esExports = { render: QuickAdd_render, staticRenderFns: QuickAdd_staticRenderFns }
/* harmony default export */ var components_QuickAdd = (QuickAdd_esExports);
// CONCATENATED MODULE: ./src/components/QuickAdd.vue
var QuickAdd_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var QuickAdd___vue_template_functional__ = false
/* styles */
var QuickAdd___vue_styles__ = null
/* scopeId */
var QuickAdd___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var QuickAdd___vue_module_identifier__ = null
var QuickAdd_Component = QuickAdd_normalizeComponent(
  QuickAdd,
  components_QuickAdd,
  QuickAdd___vue_template_functional__,
  QuickAdd___vue_styles__,
  QuickAdd___vue_scopeId__,
  QuickAdd___vue_module_identifier__
)

/* harmony default export */ var src_components_QuickAdd = (QuickAdd_Component.exports);

// CONCATENATED MODULE: ./src/router/pixel.js
var pixel = function pixel() {
  if (!window.fbq) {
    return;
  }

  window.fbq('track', 'PageView');
};

/* harmony default export */ var router_pixel = (pixel);
// CONCATENATED MODULE: ./src/router/google.js
var GA_ID = "";

function gtag() {
  window.dataLayer.push(arguments);
}

var google = function google(_ref) {
  var path = _ref.path;

  gtag('config', GA_ID, {
    page_path: path
  });
};

/* harmony default export */ var router_google = (google);
// CONCATENATED MODULE: ./src/router/index.js










vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: src_components_Home
  }, {
    path: '/categorie/:categorySlug([a-z0-9-]+)',
    name: 'category',
    component: src_components_Category,
    props: function props(route) {
      return {
        categorySlug: route.params.categorySlug,
        nomineeId: null
      };
    }
  }, {
    path: '/inzenden',
    name: 'submit',
    component: src_components_Submit
  }, {
    path: '/bevestigen/:uuid([a-z0-9-]{36})',
    name: 'confirm',
    component: src_components_Confirm,
    props: function props(route) {
      return {
        uuid: route.params.uuid
      };
    }
  }, {
    path: '*',
    redirect: '/'
  }, {
    path: '/:categorySlug([a-z0-9-]+)/:nomineeSlug([a-z0-9-]+)',
    name: 'quick_add',
    component: src_components_QuickAdd,
    props: function props(route) {
      return {
        categorySlug: route.params.categorySlug,
        nomineeSlug: route.params.nomineeSlug
      };
    }
  }]
});

router.afterEach(function (to) {
  try {
    router_pixel(to);
    router_google(to);
  } catch (e) {
    console.warn(e);
  }
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/store/actions.js
/* harmony default export */ var actions = ({
  setLoaded: function setLoaded(_ref, loaded) {
    var commit = _ref.commit;

    commit('setLoaded', loaded);
  },
  setNominees: function setNominees(_ref2, nominees) {
    var commit = _ref2.commit;

    commit('setNominees', nominees);
  },
  setCategories: function setCategories(_ref3, nominees) {
    var commit = _ref3.commit;

    commit('setCategories', nominees);
  },
  setRounds: function setRounds(_ref4, nominees) {
    var commit = _ref4.commit;

    commit('setRounds', nominees);
  },
  selectNominee: function selectNominee(_ref5, _ref6) {
    var commit = _ref5.commit;
    var categoryId = _ref6.categoryId,
        nomineeId = _ref6.nomineeId;

    commit('selectNominee', { categoryId: categoryId, nomineeId: nomineeId });
  },
  addSuggestion: function addSuggestion(_ref7, _ref8) {
    var commit = _ref7.commit;
    var categoryId = _ref8.categoryId,
        suggestionName = _ref8.suggestionName;

    commit('addSuggestion', { categoryId: categoryId, suggestionName: suggestionName });
  },
  clearSelected: function clearSelected(_ref9) {
    var commit = _ref9.commit;

    commit('clearSelected');
  },
  clearCategory: function clearCategory(_ref10, _ref11) {
    var commit = _ref10.commit;
    var categoryId = _ref11.categoryId;

    commit('clearCategory', { categoryId: categoryId });
  },
  setSelectedChannelId: function setSelectedChannelId(_ref12, _ref13) {
    var commit = _ref12.commit;
    var categoryId = _ref13.categoryId,
        tagId = _ref13.tagId;

    commit('setSelectedChannelId', { categoryId: categoryId, tagId: tagId });
  },
  setSelectedDayPartId: function setSelectedDayPartId(_ref14, _ref15) {
    var commit = _ref14.commit;
    var categoryId = _ref15.categoryId,
        tagId = _ref15.tagId;

    commit('setSelectedDayPartId', { categoryId: categoryId, tagId: tagId });
  },
  setKeyword: function setKeyword(_ref16, _ref17) {
    var commit = _ref16.commit;
    var categoryId = _ref17.categoryId,
        keyword = _ref17.keyword;

    commit('setKeyword', { categoryId: categoryId, keyword: keyword });
  },
  setSortType: function setSortType(_ref18, _ref19) {
    var commit = _ref18.commit;
    var categoryId = _ref19.categoryId,
        sortType = _ref19.sortType;

    commit('setSortType', { categoryId: categoryId, sortType: sortType });
  },
  setAllowSuggestions: function setAllowSuggestions(_ref20, allowSuggestions) {
    var commit = _ref20.commit;

    commit('setAllowSuggestions', allowSuggestions);
  },
  setFailedFetch: function setFailedFetch(_ref21, failed) {
    var commit = _ref21.commit;

    commit('setFailedFetch', { failed: failed });
  }
});
// CONCATENATED MODULE: ./src/store/getters.js
/* harmony default export */ var getters = ({
  selection: function selection(state) {
    return state.categories.map(function (category) {
      var selectedNominee = state.selected.find(function (_ref) {
        var categoryId = _ref.categoryId;
        return parseInt(categoryId) === parseInt(category.id);
      });
      return {
        category: category,
        nominee: selectedNominee ? // ? state.nominees.find(nominee => nominee.id === selectedNominee.nomineeId)
        state.nominees.find(function (nominee) {
          return nominee.id === selectedNominee.nomineeId && nominee.category.id === category.id;
        }) : null,
        suggestion: selectedNominee && typeof selectedNominee.suggestionName !== 'undefined' ? selectedNominee : null
      };
    });
  },

  getNomineesByCategoryId: function getNomineesByCategoryId(state) {
    return function (categoryId) {
      return state.nominees.filter(function (_ref2) {
        var category = _ref2.category;
        return category.id === categoryId;
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    };
  },

  getFilteredNomineesByCategoryId: function getFilteredNomineesByCategoryId(state, getters) {
    return function (categoryId) {
      var filtered = getters.getNomineesByCategoryId(categoryId);

      return filtered.sort(function (a, b) {
        return 0.5 - Math.random();
      });
    };
  }
});
// CONCATENATED MODULE: ./src/store/mutations.js
/* harmony default export */ var mutations = ({
  setLoaded: function setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setNominees: function setNominees(state, nominees) {
    state.nominees = nominees;
  },
  setCategories: function setCategories(state, categories) {
    state.categories = categories;
  },
  setRounds: function setRounds(state, rounds) {
    state.rounds = rounds;
  },
  selectNominee: function selectNominee(state, _ref) {
    var categoryId = _ref.categoryId,
        nomineeId = _ref.nomineeId;

    var cleared = state.selected.filter(function (choice) {
      return !(choice.categoryId === categoryId);
    });

    state.selected = cleared.concat([{ categoryId: categoryId, nomineeId: nomineeId }]);
  },
  addSuggestion: function addSuggestion(state, _ref2) {
    var categoryId = _ref2.categoryId,
        suggestionName = _ref2.suggestionName;

    var cleared = state.selected.filter(function (choice) {
      return !(choice.categoryId === categoryId);
    });
    state.selected = cleared.concat([{ categoryId: categoryId, suggestionName: suggestionName }]);
    state.suggestions.push({ suggestionName: suggestionName, categoryId: categoryId });
  },
  clearCategory: function clearCategory(state, _ref3) {
    var categoryId = _ref3.categoryId;

    state.selected = state.selected.filter(function (choice) {
      return !(choice.categoryId === categoryId);
    });
  },
  clearSelected: function clearSelected(state) {
    state.selected = [];
  },
  setSelectedChannelId: function setSelectedChannelId(state, _ref4) {
    var categoryId = _ref4.categoryId,
        tagId = _ref4.tagId;

    var category = state.categories.find(function (_ref5) {
      var id = _ref5.id;
      return id === categoryId;
    });

    category.selectedChannelId = category.selectedChannelId === tagId ? null : tagId;
  },
  setSelectedDayPartId: function setSelectedDayPartId(state, _ref6) {
    var categoryId = _ref6.categoryId,
        tagId = _ref6.tagId;

    var category = state.categories.find(function (_ref7) {
      var id = _ref7.id;
      return id === categoryId;
    });

    category.selectedDayPartId = category.selectedDayPartId === tagId ? null : tagId;
  },
  setKeyword: function setKeyword(state, _ref8) {
    var categoryId = _ref8.categoryId,
        keyword = _ref8.keyword;

    var category = state.categories.find(function (_ref9) {
      var id = _ref9.id;
      return id === categoryId;
    });

    category.keyword = keyword;
  },
  setSortType: function setSortType(state, _ref10) {
    var categoryId = _ref10.categoryId,
        sortType = _ref10.sortType;

    var category = state.categories.find(function (_ref11) {
      var id = _ref11.id;
      return id === categoryId;
    });

    category.sortType = sortType;
  },
  setAllowSuggestions: function setAllowSuggestions(state, allowSuggestions) {
    state.allowSuggestions = allowSuggestions;
  },
  setFailedFetch: function setFailedFetch(state) {
    state.failedFetch = true;
  }
});
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  state: {
    loaded: false,
    failedFetch: false,
    allowSuggestions: false,
    rounds: [],
    categories: [],
    nominees: [],
    selected: [],
    votes: [],
    suggestions: []
  },
  actions: actions,
  getters: getters,
  mutations: mutations
});

/* harmony default export */ var src_store = (store);
// CONCATENATED MODULE: ./src/main.js
























/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  store: src_store,
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "S4k7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "czUQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dNEa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lONR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pb+Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pz9T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tYzW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xsZ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yg31":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/main.1577b7f0b04e8d8c1d65.js